
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("euw6P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $477dG = parcelRequire("477dG");


var $fzXn1 = parcelRequire("fzXn1");


var $cQHTi = parcelRequire("cQHTi");


var $gVoWJ = parcelRequire("gVoWJ");


var $1JdaQ = parcelRequire("1JdaQ");


var $agrUc = parcelRequire("agrUc");


var $eyggb = parcelRequire("eyggb");


var $fYKTL = parcelRequire("fYKTL");


var $5HHoF = parcelRequire("5HHoF");


var $5u7tz = parcelRequire("5u7tz");


var $gCiM9 = parcelRequire("gCiM9");


var $i2zv0 = parcelRequire("i2zv0");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $jhcFr = parcelRequire("jhcFr");





var $1S4f7 = parcelRequire("1S4f7");


var $l6okE = parcelRequire("l6okE");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $4pEXC = parcelRequire("4pEXC");

const $88bdc5831095534b$export$811d95c3175e32b1 = ({ config: { onArrowUp: onArrowUp, onArrowDown: onArrowDown, onInputChange: onInputChange }, api: api })=>{
    return {
        name: 'arrowKeyPlugin',
        pmPlugins () {
            return [
                {
                    name: 'arrowKeyPlugin',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            props: {
                                handleTextInput: ()=>{
                                    onInputChange();
                                },
                                handleKeyDown: (view, event)=>{
                                    if (event.key === 'Backspace') onInputChange();
                                    if (!(0, $l6okE.atTheBeginningOfDoc)(view.state)) return;
                                    if (event.key === 'ArrowUp') onArrowUp({
                                        replaceDocument: (value)=>api?.core.actions.replaceDocument(value),
                                        view: view
                                    });
                                    else if (event.key === 'ArrowDown') onArrowDown({
                                        replaceDocument: (value)=>{
                                            api?.core.actions.replaceDocument(value);
                                            // Needed because the down arrow by default moves the cursor to the end of the input
                                            // preventDefault, stopPropagation, etc. doesn't work to prevent this in this callback
                                            // So we need to wait for the next tick to move the cursor to the start of the input
                                            new Promise((resolve)=>{
                                                setTimeout(()=>{
                                                    view.dispatch(view.state.tr.setSelection(new (0, $ks2lK.TextSelection)(view.state.tr.doc.resolve(0), view.state.tr.doc.resolve(0))));
                                                    resolve(true);
                                                }, 0);
                                            });
                                        },
                                        view: view
                                    });
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};
const $88bdc5831095534b$export$bb1e6e55f39d8be9 = ({ userMessages: userMessages })=>{
    const storeMessagesRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(userMessages);
    storeMessagesRef.current = userMessages;
    const currentMessageRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        currentMessageRef.current = undefined;
    }, [
        userMessages.length
    ]);
    const moveMessageUpOrDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, position: position, view: view })=>{
        const increment = position === 'up' ? -1 : 1;
        const isEmpty = (0, $2pjJ5.isEmptyDocument)(view.state.doc);
        if (!storeMessagesRef.current.length) return;
        // If the input is not empty and the current message is not set(it's not the history message), do nothing
        if (!isEmpty && currentMessageRef.current === undefined) return;
        const currentMessageIndex = currentMessageRef.current ? storeMessagesRef.current.findIndex((message)=>message.id === currentMessageRef.current?.id) : storeMessagesRef.current.length;
        // If the currentindex is humanMessages.length, the next index will either be the last message (pressing up)
        // or out of bounds (pressing down and resetting the current message to undefined)
        const newMessageIndex = Math.max(0, currentMessageIndex + increment);
        const newMessage = storeMessagesRef.current[newMessageIndex];
        currentMessageRef.current = newMessage;
        replaceDocument(newMessage?.content ?? (0, $4pEXC.encodeAdf)(''));
    }, []);
    const handleArrowUp = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, view: view })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument,
            position: 'up',
            view: view
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleArrowDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, view: view })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument,
            position: 'down',
            view: view
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        // Reset the current message to undefined when input gets updated
        currentMessageRef.current = undefined;
    }, []);
    return {
        handleArrowUp: handleArrowUp,
        handleArrowDown: handleArrowDown,
        handleInputChange: handleInputChange
    };
};



var $jF2zj = parcelRequire("jF2zj");




const $5335087dbbae3a25$var$message = (0, $aXWIB.defineMessages)({
    placeholder: {
        id: "ai-mate.chat-input.placeholder",
        defaultMessage: "Write a prompt to get started"
    },
    placeholderUpdated: {
        id: "ai-mate.chat-input.placeholder.updated.latest",
        defaultMessage: "Write a prompt, @mentions someone, or use / for actions"
    },
    placeholderShort: {
        id: "ai-mate.chat-input.placeholder.short",
        defaultMessage: "Write a prompt..."
    }
});
var $5335087dbbae3a25$export$2e2bcd8739ae039 = $5335087dbbae3a25$var$message;






var $5SAOw = parcelRequire("5SAOw");

/**
 * Removes textColor marks from a ProseMirror Slice.
 *
 * When users manually copy text from an area that has an explicit text color
 * (e.g. white text on a dark chat-bubble background) and then paste it into
 * the chat input, the color mark is preserved.  Because the input has a light
 * background the text can become invisible.
 *
 * This helper recursively walks every node in the slice and strips the
 * `textColor` mark so that pasted content always uses the editor's default
 * text color.
 */ function $5b867109aa9f0a91$var$removeTextColorFromNode(node) {
    if (node.isText) {
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'textColor');
        return node.mark(filteredMarks);
    }
    if (node.content && node.content.size > 0) {
        const children = [];
        node.content.forEach((child)=>{
            children.push($5b867109aa9f0a91$var$removeTextColorFromNode(child));
        });
        return node.copy((0, $5SAOw.Fragment).from(children));
    }
    return node;
}
function $5b867109aa9f0a91$var$removeTextColorFromSlice(slice) {
    const { content: content, openStart: openStart, openEnd: openEnd } = slice;
    const children = [];
    content.forEach((node)=>{
        children.push($5b867109aa9f0a91$var$removeTextColorFromNode(node));
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(children), openStart, openEnd);
}
const $5b867109aa9f0a91$export$5503306a243aac08 = ()=>{
    return {
        name: 'pasteTextColorPlugin',
        pmPlugins () {
            return [
                {
                    name: 'pasteTextColorPlugin',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            props: {
                                transformPasted (slice) {
                                    return $5b867109aa9f0a91$var$removeTextColorFromSlice(slice);
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};


const $dd4d4a3c0d9a1cfa$export$451e6f6982270493 = 256000;
const $dd4d4a3c0d9a1cfa$export$22e9fc2aa16bb38f = ({ onSave: onSave, arrowKeyPluginConfig: arrowKeyPluginConfig, productKey: productKey, siteId: siteId, placeholderPrompts: placeholderPrompts, placeholderText: placeholderText, linkPickerOptions: linkPickerOptions = {}, useShortMessages: useShortMessages = false, connectorSources: connectorSources = [] })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(linkPickerOptions, {
        cloudId: siteId,
        product: productKey
    });
    const { handleArrowDown: handleArrowDown, handleArrowUp: handleArrowUp, handleInputChange: handleInputChange } = (0, $88bdc5831095534b$export$bb1e6e55f39d8be9)({
        userMessages: arrowKeyPluginConfig.userMessages
    });
    const knownSourcesRef = (0, $42omo.useRef)(connectorSources);
    knownSourcesRef.current = connectorSources;
    const { preset: preset, editorApi: editorApi } = (0, $1JdaQ.usePreset)(()=>{
        const isUpdatedPlaceholderEnabled = ()=>(0, $c6GJD.default).getExperimentValue('rovo-chat-input-placeholder-updated', 'isEnabled', false);
        const enableConnectorSourceIconChip = (0, $dh538.fg)('rovo_chat_app_chip_inline_icon');
        const placeholderConfig = placeholderPrompts && (0, $dh538.fg)('aifc_create_enabled') ? {
            placeholderPrompts: placeholderPrompts
        } : placeholderText ? {
            placeholder: placeholderText
        } : {
            placeholder: formatMessage(useShortMessages ? (0, $5335087dbbae3a25$export$2e2bcd8739ae039).placeholderShort : isUpdatedPlaceholderEnabled() ? (0, $5335087dbbae3a25$export$2e2bcd8739ae039).placeholderUpdated : (0, $5335087dbbae3a25$export$2e2bcd8739ae039).placeholder)
        };
        return (0, $gVoWJ.createDefaultPreset)({
            placeholder: placeholderConfig,
            paste: {
                pasteWarningOptions: (0, $dh538.fg)('platform_synced_block_unsupported_products') ? {
                    cannotPasteSyncedBlock: {
                        title: (0, $fzXn1.syncBlockMessages).cannotPasteSyncedBlockTitle,
                        description: (0, $fzXn1.syncBlockMessages).cannotPasteSyncedBlockUnsupportedDescription,
                        urlHref: (0, $cQHTi.SYNCED_BLOCKS_DOCUMENTATION_URL),
                        urlText: (0, $fzXn1.syncBlockMessages).cannotPasteSyncedBlockAction
                    }
                } : undefined
            },
            hyperlinkOptions: {
                linkPicker: linkPicker,
                lpLinkPicker: true
            },
            blockType: {
                allowBlockType: {
                    exclude: [
                        'heading'
                    ]
                },
                lastNodeMustBeParagraph: !(0, $1oCLl.expValEquals)('platform_editor_disable_last_node_para', 'isEnabled', true)
            },
            toolbar: {
                enableNewToolbarExperience: false
            }
        }).add([
            (0, $gCiM9.saveOnEnterPlugin),
            onSave
        ]).add((0, $5u7tz.mentionsPlugin)).add((0, $fYKTL.gridPlugin)).add([
            (0, $agrUc.cardPlugin),
            {
                allowBlockCards: false,
                allowEmbeds: false,
                linkPicker: linkPicker,
                lpLinkPicker: true,
                provider: Promise.resolve((0, $477dG.editorCardProvider))
            }
        ]).add((0, $5HHoF.listPlugin)).add((0, $eyggb.extensionPlugin)).maybeAdd([
            (0, $jF2zj.connectorSourceInputRulePlugin),
            {
                knownSourcesRef: knownSourcesRef,
                enableIconChip: enableConnectorSourceIconChip
            }
        ], (0, $c6GJD.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false, {
            fireExperimentExposure: false
        })).add((0, $i2zv0.textColorPlugin)).add((0, $5b867109aa9f0a91$export$5503306a243aac08)).add([
            (0, $88bdc5831095534b$export$811d95c3175e32b1),
            {
                onArrowDown: handleArrowDown,
                onArrowUp: handleArrowUp,
                onInputChange: handleInputChange
            }
        ]);
    }, []);
    return {
        preset: preset,
        editorApi: editorApi
    };
};
module.exports["MAX_CHARACTERS_INPUT"] = $dd4d4a3c0d9a1cfa$export$451e6f6982270493;
module.exports["useEditorPreset"] = $dd4d4a3c0d9a1cfa$export$22e9fc2aa16bb38f;

});

parcelRegister("jF2zj", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");

const $8db4013318166625$export$4a57230fe42df70d = 'connectorSourceChip';
const $8db4013318166625$var$getAttr = (dom, attrName)=>{
    const value = dom.getAttribute(attrName);
    return value ?? undefined;
};
const $8db4013318166625$export$ad2ec06a68289c0d = (attrs)=>[
        'span',
        {
            'data-connector-source-chip': 'true',
            'data-source': attrs.source,
            'data-display': attrs.display,
            ...attrs.iconUrl ? {
                'data-icon-url': attrs.iconUrl
            } : {}
        },
        attrs.display
    ];
const $8db4013318166625$export$2f76c91f5ec44cda = {
    inline: true,
    group: 'inline',
    atom: true,
    attrs: {
        source: {
            default: ''
        },
        display: {
            default: ''
        },
        iconUrl: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[data-connector-source-chip]',
            getAttrs: (dom)=>{
                if (!(dom instanceof HTMLElement)) return false;
                return {
                    source: $8db4013318166625$var$getAttr(dom, 'data-source') ?? '',
                    display: $8db4013318166625$var$getAttr(dom, 'data-display') ?? dom.textContent ?? '',
                    iconUrl: $8db4013318166625$var$getAttr(dom, 'data-icon-url')
                };
            }
        }
    ],
    toDOM: (node)=>$8db4013318166625$export$ad2ec06a68289c0d({
            source: node.attrs.source,
            display: node.attrs.display,
            iconUrl: node.attrs.iconUrl
        }),
    leafText: (node)=>node.attrs.display
};


/* create-chip-node-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2FNjD = parcelRequire("2FNjD");


var $hTKp4 = parcelRequire("hTKp4");


var $52Dfo = parcelRequire("52Dfo");


const $8c94d4b555849703$var$ICON_SIZE = 12;
const $8c94d4b555849703$var$iconSlotExpand = null;
const $8c94d4b555849703$var$chipStyles = null;
const $8c94d4b555849703$var$innerStyles = null;
const $8c94d4b555849703$var$iconSlotStyles = null;
const $8c94d4b555849703$var$iconBoxStyles = null;
const $8c94d4b555849703$var$skeletonStyles = null;
const $8c94d4b555849703$var$remoteIconStyles = null;
const $8c94d4b555849703$var$hiddenStyles = null;
const $8c94d4b555849703$var$labelStyles = null;
const $8c94d4b555849703$var$getStringAttr = (value)=>typeof value === 'string' ? value : '';
const $8c94d4b555849703$var$getChipAttrs = (node)=>({
        source: $8c94d4b555849703$var$getStringAttr(node.attrs.source),
        display: $8c94d4b555849703$var$getStringAttr(node.attrs.display),
        iconUrl: $8c94d4b555849703$var$getStringAttr(node.attrs.iconUrl) || undefined
    });
const $8c94d4b555849703$var$ConnectorSourceChipIcon = /*#__PURE__*/ (0, $42omo.memo)(({ source: source, iconUrl: iconUrl })=>{
    const [isRemoteIconLoading, setIsRemoteIconLoading] = (0, $42omo.useState)(Boolean(iconUrl));
    const [hasRemoteIconError, setHasRemoteIconError] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setIsRemoteIconLoading(Boolean(iconUrl));
        setHasRemoteIconError(false);
    }, [
        iconUrl,
        source
    ]);
    const localIcon = (0, $42omo.useMemo)(()=>(0, $52Dfo.getKnowledgeSourceIcon)(source, {
            size: $8c94d4b555849703$var$ICON_SIZE
        }), [
        source
    ]);
    const fallbackIcon = (0, $42omo.useMemo)(()=>(0, $52Dfo.getKnowledgeSourceIcon)('app', {
            size: $8c94d4b555849703$var$ICON_SIZE
        }), []);
    const showRemoteIcon = !localIcon && iconUrl && !hasRemoteIconError;
    let content;
    if (localIcon) content = localIcon;
    else if (showRemoteIcon) content = /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        children: [
            isRemoteIconLoading && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_2rkolb4i _1e0c1ule _1bsb1crf _4t3i1crf _bfhkizff"
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: iconUrl,
                alt: "",
                width: $8c94d4b555849703$var$ICON_SIZE,
                height: $8c94d4b555849703$var$ICON_SIZE,
                referrerPolicy: "no-referrer",
                onLoad: ()=>setIsRemoteIconLoading(false),
                onError: ()=>{
                    setIsRemoteIconLoading(false);
                    setHasRemoteIconError(true);
                },
                className: (0, $gMc0m.default)([
                    "_1e0c1ule _1bsb1crf _4t3i1crf _5ral1f51",
                    isRemoteIconLoading && "_1e0cglyw"
                ])
            })
        ]
    });
    else content = fallbackIcon;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_1e0c116y"
        ]),
        children: content
    });
});
$8c94d4b555849703$var$ConnectorSourceChipIcon.displayName = 'ConnectorSourceChipIcon';
const $8c94d4b555849703$var$areChipAttrsEqual = (previous, next)=>previous.source === next.source && previous.display === next.display && previous.iconUrl === next.iconUrl;
const $8c94d4b555849703$var$ConnectorSourceChip = /*#__PURE__*/ (0, $42omo.memo)(({ source: source, display: display, iconUrl: iconUrl })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": "connector-source-chip",
        "data-connector-source-chip": "true",
        "data-source": source,
        "data-display": display,
        ...iconUrl ? {
            'data-icon-url': iconUrl
        } : {},
        className: (0, $gMc0m.default)([
            "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko12b0 _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhki8nm _v8fhqvcn _16d9qvcn _syazi7uo _1i4q1hna _o5721jtm"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("span", {
            className: (0, $gMc0m.default)([
                "_zulpv77o _1e0c116y _4cvr1q9y"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _1bah1h6o _1bsb1crf _4t3i1crf _1o9zidpf _s7n4nkob _t9ectfbr _j7hq17zd _5sagdn4k _1pglindk _1o51eoah _bl8aglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($8c94d4b555849703$var$ConnectorSourceChipIcon, {
                        source: source,
                        iconUrl: iconUrl
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_11c81kw7"
                    ]),
                    children: display
                })
            ]
        })
    });
});
$8c94d4b555849703$var$ConnectorSourceChip.displayName = 'ConnectorSourceChip';
const $8c94d4b555849703$var$renderChip = (root, attrs)=>{
    const { source: source, display: display, iconUrl: iconUrl } = attrs;
    root.render(/*#__PURE__*/ (0, $l998X.jsx)($8c94d4b555849703$var$ConnectorSourceChip, {
        source: source,
        display: display,
        iconUrl: iconUrl
    }));
};
const $8c94d4b555849703$export$6eb44f18c777778b = (node)=>{
    const doc = (0, $hTKp4.getDocument)();
    if (!doc) throw new Error('Connector source chip node view requires a document');
    let currentAttrs = $8c94d4b555849703$var$getChipAttrs(node);
    const dom = doc.createElement('span');
    const root = (0, $2FNjD.createRoot)(dom);
    $8c94d4b555849703$var$renderChip(root, currentAttrs);
    return {
        dom: dom,
        update (nextNode) {
            if (nextNode.type.name !== (0, $8db4013318166625$export$4a57230fe42df70d)) return false;
            const nextAttrs = $8c94d4b555849703$var$getChipAttrs(nextNode);
            if ($8c94d4b555849703$var$areChipAttrsEqual(currentAttrs, nextAttrs)) return true;
            currentAttrs = nextAttrs;
            $8c94d4b555849703$var$renderChip(root, currentAttrs);
            return true;
        },
        destroy () {
            queueMicrotask(()=>root.unmount());
        }
    };
};


const $927f475abe008e0f$var$hasObjectShape = (value)=>typeof value === 'object' && value !== null;
const $927f475abe008e0f$var$getConnectorSourceDisplay = (value)=>{
    if (!$927f475abe008e0f$var$hasObjectShape(value) || !$927f475abe008e0f$var$hasObjectShape(value.attrs)) return '';
    return typeof value.attrs.display === 'string' ? value.attrs.display : '';
};
const $927f475abe008e0f$var$normalizeConnectorSourceJson = (_key, value)=>{
    if ($927f475abe008e0f$var$hasObjectShape(value) && value.type === (0, $8db4013318166625$export$4a57230fe42df70d)) return {
        type: 'text',
        text: $927f475abe008e0f$var$getConnectorSourceDisplay(value)
    };
    return value;
};
const $927f475abe008e0f$export$d2725e20f7d4ea3e = (doc)=>JSON.parse(JSON.stringify(doc, $927f475abe008e0f$var$normalizeConnectorSourceJson));
const $927f475abe008e0f$export$9de1f4debe7f2e29 = (textBefore, sources)=>{
    const lower = textBefore.toLowerCase();
    for (const entry of sources){
        const { key: key, display: display } = entry;
        if (lower.endsWith(key)) {
            const startOffset = textBefore.length - key.length;
            if (startOffset === 0 || /\s/.test(textBefore[startOffset - 1])) return {
                entry: entry,
                name: display,
                startOffset: startOffset
            };
        }
    }
    return null;
};
const $927f475abe008e0f$export$c572ae05ff1a3f = (view, event)=>{
    if (event.key !== 'Backspace') return false;
    const { state: state } = view;
    const { selection: selection } = state;
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    const nodeBefore = $from.nodeBefore;
    if (nodeBefore?.type.name === (0, $8db4013318166625$export$4a57230fe42df70d)) {
        const chipEndPosition = $from.pos;
        const chipStartPosition = chipEndPosition - nodeBefore.nodeSize;
        event.preventDefault();
        view.dispatch(state.tr.delete(chipStartPosition, chipEndPosition));
        return true;
    }
    if (nodeBefore?.isText && nodeBefore.text === ' ') {
        const positionBeforeSpace = $from.pos - 1;
        const resolvedPositionBeforeSpace = state.doc.resolve(positionBeforeSpace);
        const nodeBeforeSpace = resolvedPositionBeforeSpace.nodeBefore;
        if (nodeBeforeSpace?.type.name === (0, $8db4013318166625$export$4a57230fe42df70d)) {
            const chipStartPosition = positionBeforeSpace - nodeBeforeSpace.nodeSize;
            event.preventDefault();
            view.dispatch(state.tr.delete(chipStartPosition, $from.pos));
            return true;
        }
    }
    return false;
};
const $927f475abe008e0f$var$insertLegacyCodeChip = ({ schema: schema, match: match, absoluteStart: absoluteStart, absoluteEnd: absoluteEnd, view: view })=>{
    const codeMark = schema.marks.code;
    if (!codeMark) return false;
    const codeTextNode = schema.text(match.name, [
        codeMark.create()
    ]);
    const tr = view.state.tr.replaceWith(absoluteStart, absoluteEnd, [
        codeTextNode,
        schema.text(' ')
    ]);
    view.dispatch(tr);
    return true;
};
const $927f475abe008e0f$export$ae76e6cef034bf3b = ({ view: view, schema: schema, from: from, text: text, sourceNames: sourceNames, enableIconChip: enableIconChip })=>{
    if (text !== ' ') return false;
    if (!sourceNames.length) return false;
    const { state: state } = view;
    const { $from: $from } = state.selection;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc') + '';
    const match = $927f475abe008e0f$export$9de1f4debe7f2e29(textBefore, sourceNames);
    if (!match) return false;
    const absoluteStart = $from.start() + match.startOffset;
    const absoluteEnd = from;
    if (!enableIconChip) return $927f475abe008e0f$var$insertLegacyCodeChip({
        schema: schema,
        match: match,
        absoluteStart: absoluteStart,
        absoluteEnd: absoluteEnd,
        view: view
    });
    const connectorSourceChipNode = schema.nodes[0, $8db4013318166625$export$4a57230fe42df70d];
    if (!connectorSourceChipNode) return $927f475abe008e0f$var$insertLegacyCodeChip({
        schema: schema,
        match: match,
        absoluteStart: absoluteStart,
        absoluteEnd: absoluteEnd,
        view: view
    });
    const chipNode = connectorSourceChipNode.create({
        source: match.entry.source ?? match.entry.key,
        display: match.entry.display,
        iconUrl: match.entry.iconUrl ?? null
    });
    const tr = state.tr.replaceWith(absoluteStart, absoluteEnd, [
        chipNode,
        schema.text(' ')
    ]);
    view.dispatch(tr);
    return true;
};
const $927f475abe008e0f$export$f6f01fc440f7b697 = ({ config: { knownSourcesRef: knownSourcesRef, enableIconChip: enableIconChip = false } })=>{
    return {
        name: 'connectorSourceInputRule',
        ...enableIconChip ? {
            nodes () {
                return [
                    {
                        name: (0, $8db4013318166625$export$4a57230fe42df70d),
                        node: (0, $8db4013318166625$export$2f76c91f5ec44cda)
                    }
                ];
            }
        } : {},
        pmPlugins () {
            return [
                {
                    name: 'connectorSourceInputRule',
                    plugin: ({ schema: schema })=>{
                        return new (0, $1S4f7.SafePlugin)({
                            props: {
                                handleKeyDown (view, event) {
                                    if (!enableIconChip) return false;
                                    return $927f475abe008e0f$export$c572ae05ff1a3f(view, event);
                                },
                                ...enableIconChip ? {
                                    nodeViews: {
                                        [(0, $8db4013318166625$export$4a57230fe42df70d)]: (pmNode)=>(0, $8c94d4b555849703$export$6eb44f18c777778b)(pmNode)
                                    }
                                } : {},
                                handleTextInput (view, from, _to, text) {
                                    return $927f475abe008e0f$export$ae76e6cef034bf3b({
                                        view: view,
                                        schema: schema,
                                        from: from,
                                        text: text,
                                        sourceNames: knownSourcesRef.current,
                                        enableIconChip: enableIconChip
                                    });
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["normalizeConnectorSourceDoc"] = $927f475abe008e0f$export$d2725e20f7d4ea3e;
module.exports["connectorSourceInputRulePlugin"] = $927f475abe008e0f$export$f6f01fc440f7b697;

});

parcelRegister("5fzJo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a2921a3f0cac1584$var$initialState = {};
const $a2921a3f0cac1584$export$f80440bac8b4447 = $a2921a3f0cac1584$var$initialState;
const $a2921a3f0cac1584$var$rovoMentionProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($a2921a3f0cac1584$var$initialState);
const $a2921a3f0cac1584$export$188c81c2e93279c4 = $a2921a3f0cac1584$var$rovoMentionProvider.Provider;
const $a2921a3f0cac1584$export$c577383a2f7ca57d = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($a2921a3f0cac1584$var$rovoMentionProvider);
module.exports["useRovoMentionProvider"] = $a2921a3f0cac1584$export$c577383a2f7ca57d;

});

parcelRegister("2e6ow", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4pEXC = parcelRequire("4pEXC");

const $e5657d5e856c1c46$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        placeholder: null
    },
    actions: {
        setPlaceholder: (placeholder)=>({ setState: setState })=>{
                setState({
                    placeholder: placeholder
                });
            }
    }
});
const $e5657d5e856c1c46$export$caaec55db704374b = (0, $9zUhf.createHook)($e5657d5e856c1c46$var$state);
const $e5657d5e856c1c46$var$getPlaceholderType = (placeholderLabel)=>{
    switch(placeholderLabel){
        case 'person':
            return 'person';
        case 'skill':
            return 'skill';
        default:
            return 'link';
    }
};
const $e5657d5e856c1c46$var$isPromptWithPlaceholder = (prompt)=>{
    return prompt.includes((0, $4pEXC.PROMPT_PLACEHOLDER_CHAR));
};
const $e5657d5e856c1c46$export$96ba721a063d462c = ()=>{
    const [{ placeholder: placeholder }, { setPlaceholder: setPlaceholder }] = $e5657d5e856c1c46$export$caaec55db704374b();
    const insertPlaceholder = (0, $42omo.useCallback)((prompt, overrideType, skillMetadata)=>{
        // TODO: Used for pubsub listener events to convert skill tags to ADF. Remove this once we have a better solution.
        if (overrideType === 'skill') {
            const { adf: adf, promptLength: promptLength } = (0, $4pEXC.encodeSkillPromptToAdf)(prompt);
            setPlaceholder({
                prompt: prompt,
                adfDocument: adf,
                type: 'generic',
                selectionStartIndex: promptLength,
                selectionEndIndex: promptLength
            });
            return;
        }
        const { adf: adf, promptLength: promptLength, placeholderRange: placeholderRange } = (0, $4pEXC.encodePromptToAdf)(prompt, skillMetadata, true);
        const type = placeholderRange ? overrideType ?? $e5657d5e856c1c46$var$getPlaceholderType(placeholderRange.label) : 'generic';
        setPlaceholder({
            prompt: prompt,
            adfDocument: adf,
            type: type,
            selectionStartIndex: placeholderRange?.start ?? promptLength + 1,
            selectionEndIndex: placeholderRange?.end ?? promptLength + 1
        });
    }, [
        setPlaceholder
    ]);
    const insertInlineCard = (0, $42omo.useCallback)((url)=>{
        const adfDocument = {
            version: 1,
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'inlineCard',
                            attrs: {
                                url: url
                            }
                        },
                        {
                            type: 'text',
                            text: ' '
                        }
                    ]
                }
            ]
        };
        setPlaceholder({
            prompt: url,
            adfDocument: adfDocument,
            type: 'generic',
            selectionStartIndex: 3,
            selectionEndIndex: 3
        });
    }, [
        setPlaceholder
    ]);
    /**
	 * Inserts a placeholder with a pre-built ADF document.
	 * Places cursor at start of content (position 2) to avoid position calculation issues.
	 * Use this when you have content with inline cards or other complex ADF nodes.
	 */ const insertPlaceholderWithAdf = (0, $42omo.useCallback)((prompt, adfDocument)=>{
        // Position 2 is always valid: doc(0) > paragraph(1) > content start(2)
        setPlaceholder({
            prompt: prompt,
            adfDocument: adfDocument,
            type: 'generic',
            selectionStartIndex: 2,
            selectionEndIndex: 2
        });
    }, [
        setPlaceholder
    ]);
    const clearPlaceholder = (0, $42omo.useCallback)(()=>{
        setPlaceholder(null);
    }, [
        setPlaceholder
    ]);
    return {
        insertPlaceholder: insertPlaceholder,
        insertPlaceholderWithAdf: insertPlaceholderWithAdf,
        insertInlineCard: insertInlineCard,
        clearPlaceholder: clearPlaceholder,
        placeholder: placeholder,
        isPromptWithPlaceholder: $e5657d5e856c1c46$var$isPromptWithPlaceholder
    };
};
module.exports["usePlaceholderStore"] = $e5657d5e856c1c46$export$caaec55db704374b;
module.exports["useEditorPlaceholder"] = $e5657d5e856c1c46$export$96ba721a063d462c;

});

parcelRegister("6Y7nw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $gdv5Z = parcelRequire("gdv5Z");


var $16lEl = parcelRequire("16lEl");


var $kIvLT = parcelRequire("kIvLT");


var $5MO1q = parcelRequire("5MO1q");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $bJOL1 = parcelRequire("bJOL1");




const $34c8be18a88f108e$var$message = (0, $aXWIB.defineMessages)({
    unsupportedFile: {
        id: "ai-mate.upload-files-to-conversation.unsupported-file",
        defaultMessage: "Unsupported file type"
    },
    unknownError: {
        id: "ai-mate.upload-files-to-conversation.unknown-error",
        defaultMessage: "There was an error uploading the file. Please try again."
    },
    fileRaiPolicyViolationError: {
        id: "ai-mate.upload-files-to-conversation.file-rai-policy-violation",
        defaultMessage: "The file might not comply with our Acceptable Use Policy. Try a different file."
    },
    failToValidateFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-title",
        defaultMessage: "Failed to validate files"
    },
    failToValidateFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-description",
        defaultMessage: "Error occurred while validating files, please try again."
    },
    invalidFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-title",
        defaultMessage: "{count, plural, one {File type} other {File types}} not supported"
    },
    invalidFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-description",
        defaultMessage: "{count, plural, one {The file \"{fileNames}\" is not supported. Reason: {reasons}} other {The following files: \"{fileNames}\" are not supported. Reason: {reasons}}}"
    },
    fileInvalidIconLabel: {
        id: "ai-mate.upload-files-to-conversation.file-invalid-icon-label",
        defaultMessage: "File is invalid"
    },
    validationErrorInvalidContentType: {
        id: "ai-mate.upload-files-to-conversation.validation-error-invalid-content-type",
        defaultMessage: "File type is not supported"
    },
    validationErrorFileTooLarge: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-too-large",
        defaultMessage: "File size is too large"
    },
    validationErrorFileNameMissing: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-name-missing",
        defaultMessage: "File name is missing"
    },
    validationErrorUnknownError: {
        id: "ai-mate.upload-files-to-conversation.validation-error-unknown-error",
        defaultMessage: "Fail to validate file for unknown reason"
    },
    validationErrorMissingErrorCode: {
        id: "ai-mate.upload-files-to-conversation.validation-error-missing-error-code",
        defaultMessage: "Validation result unknown"
    },
    validationErrorNotFound: {
        id: "ai-mate.upload-files-to-conversation.validation-error-not-found",
        defaultMessage: "Validation result is not found"
    }
});
var $34c8be18a88f108e$export$2e2bcd8739ae039 = $34c8be18a88f108e$var$message;






var $flpNp = parcelRequire("flpNp");


var $3X525 = parcelRequire("3X525");


const $b19d6aa036e9e860$export$c71ec59453b6867a = (addedFiles, currentFiles)=>{
    const remainingSlots = (0, $3X525.MAX_FILES) - currentFiles.length;
    const limitedFiles = addedFiles.slice(0, remainingSlots > 0 ? remainingSlots : 0);
    return limitedFiles;
};
const $b19d6aa036e9e860$export$1156f3d82b1d9e10 = (errorCode)=>{
    switch(errorCode){
        case 'INVALID_CONTENT_TYPE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorInvalidContentType;
        case 'FILE_TOO_LARGE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorFileTooLarge;
        case 'FILE_NAME_MISSING':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorFileNameMissing;
        case 'VALIDATION_RESULT_MISSING_ERROR_CODE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorMissingErrorCode;
        case 'VALIDATION_RESULT_NOT_FOUND':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorNotFound;
        case 'UNKNOWN_ERROR':
        default:
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorUnknownError;
    }
};
const $b19d6aa036e9e860$export$4c9efc922a2449ec = (error)=>{
    if (!(0, $flpNp.isApiError)(error)) return false;
    return error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).UNSUPPORTED_FILE_TYPE || error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE || error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).FILE_RAI_POLICY_VIOLATION;
};


const $2dc4faee3a604e24$export$1e28ba9a04bf7961 = (0, $h26dv.createHookWithAssistanceService)(({ key: key, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)((0, $dpPtd.useFlags), (0, $kIvLT.useAnalytics));
    const [files, { addFiles: addFiles, removeFile: removeFile, clearFiles: clearFiles, updateFileWithName: updateFileWithName, clearAttachments: clearAttachments }] = (0, $bJOL1.useFileAttachmentsStore)(key);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const anyFilesUploading = (0, $42omo.useMemo)(()=>{
        return files.some((file)=>file.isLoading);
    }, [
        files
    ]);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { mutate: mutateUploadFiles, isSubmitting: isSubmittingUploadFiles } = (0, $29BPs.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
            addFiles(key, [
                {
                    id: '',
                    name: payload.file.name,
                    isLoading: true,
                    fileObject: payload.file
                }
            ], sendAnalyticsEvent);
            return assistanceService.uploadFiles({
                files: [
                    payload.file
                ]
            });
        },
        onSuccess: ({ data: data })=>{
            data.forEach((file)=>{
                updateFileWithName(key, file.name, {
                    id: file.id,
                    isLoading: false
                });
                sendAnalyticsEvent({
                    action: 'added',
                    actionSubject: 'rovoChatContext',
                    actionSubjectId: 'file',
                    attributes: {
                        fileType: file.type || 'unknown',
                        fileSize: file.size || 0
                    }
                });
            });
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
        },
        onError: (error, payload)=>{
            const errorMessage = (()=>{
                if (error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).UNSUPPORTED_FILE_TYPE) return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).unsupportedFile);
                if (error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE) return error.errorAttributes.rawErrorMessage;
                // Not handled by /validation due to requirement of CSAM check, we need to store the file first.
                // Check: https://atlassian.slack.com/archives/C0677M19GU9/p1751941718503669?thread_ts=1751919192.446729&cid=C0677M19GU9
                if (error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).FILE_RAI_POLICY_VIOLATION) return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).fileRaiPolicyViolationError);
                return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).unknownError);
            })();
            updateFileWithName(key, payload.file.name, {
                isLoading: false,
                isPreviewLoading: false,
                error: errorMessage
            });
            if ((0, $b19d6aa036e9e860$export$4c9efc922a2449ec)(error)) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                error: error
            });
        }
    });
    const { mutate: mutateValidateFiles, isSubmitting: isSubmittingValidateFiles } = (0, $29BPs.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).VALIDATE_FILES,
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES
            });
            return assistanceService.validateFiles({
                fileMetadata: payload.files.map((file)=>({
                        originalFilename: file.name,
                        contentType: file.type,
                        size: file.size
                    }))
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES,
                error: error
            });
        }
    });
    const handleFilesSelected = (0, $42omo.useCallback)(async (uploadedFiles)=>{
        if (!uploadedFiles?.length) return;
        const newFiles = uploadedFiles.filter((file)=>!files.some((f)=>f.name === file.name));
        // Validate files before uploading them
        const validateResponse = await mutateValidateFiles({
            files: newFiles
        });
        const getErrorIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).fileInvalidIconLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        if (!validateResponse) {
            showFlag({
                id: `conversation-files-fail-to-validate-files-${Date.now()}`,
                title: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).failToValidateFilesTitle),
                description: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).failToValidateFilesDescription),
                icon: getErrorIcon()
            });
            return;
        }
        const { validFiles: validFiles, invalidFiles: invalidFiles } = newFiles.reduce((acc, file)=>{
            const validationResult = validateResponse.validationResults.find((result)=>result.fileMetadata.originalFilename === file.name);
            if (!validationResult) {
                acc.invalidFiles.push({
                    fileName: file.name,
                    errorCode: 'VALIDATION_RESULT_NOT_FOUND'
                });
                return acc;
            }
            if (validationResult.isSupported) acc.validFiles.push(file);
            else acc.invalidFiles.push({
                fileName: validationResult.fileMetadata.originalFilename,
                errorCode: validationResult.errorCode ?? 'VALIDATION_RESULT_MISSING_ERROR_CODE'
            });
            return acc;
        }, {
            validFiles: [],
            invalidFiles: []
        });
        if (invalidFiles.length) showFlag({
            id: `conversation-files-validation-error-${Date.now()}`,
            title: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).invalidFilesTitle, {
                count: invalidFiles.length
            }),
            description: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).invalidFilesDescription, {
                count: invalidFiles.length,
                fileNames: invalidFiles.map((file)=>file.fileName).join(', '),
                reasons: Array.from(new Set(invalidFiles.map((file)=>formatMessage((0, $b19d6aa036e9e860$export$1156f3d82b1d9e10)(file.errorCode))))).join(', ')
            }),
            icon: getErrorIcon()
        });
        if (!validFiles.length) return;
        validFiles.forEach((file)=>{
            mutateUploadFiles({
                file: file
            });
        });
    }, [
        mutateUploadFiles,
        files,
        formatMessage,
        showFlag,
        mutateValidateFiles
    ]);
    const getFileInput = (0, $42omo.useCallback)((ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "file-upload-input",
            as: "input",
            ref: ref,
            hidden: true,
            type: "file",
            multiple: true,
            onChange: (e)=>{
                handleFilesSelected(Array.from(e.target.files ?? []));
                // Temporary until we only have a single file input and no ref param
                if (ref.current) ref.current.value = '';
            }
        }), [
        handleFilesSelected
    ]);
    return {
        uploadFiles: {
            isSubmitting: isSubmittingUploadFiles || isSubmittingValidateFiles
        },
        anyFilesUploading: anyFilesUploading,
        handleFilesSelected: handleFilesSelected,
        files: files,
        removeFile: removeFile,
        clearFiles: clearFiles,
        clearAttachments: clearAttachments,
        getFileInput: getFileInput
    };
});
module.exports["useConversationFiles"] = $2dc4faee3a604e24$export$1e28ba9a04bf7961;

});

parcelRegister("bJOL1", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $1yaYZ = parcelRequire("1yaYZ");


var $auPMn = parcelRequire("auPMn");


var $cgmTK = parcelRequire("cgmTK");

const $07d6ee757337fb7d$var$defaultStateContextPerKey = {
    attachments: new Map()
};
/**
 * Cleanup blob URLs for file attachments to prevent memory leaks.
 */ const $07d6ee757337fb7d$var$cleanupBlobUrls = (attachments)=>{
    attachments.forEach((attachment)=>{
        if (attachment.type === 'file' && attachment.data.previewBlobUrl) URL.revokeObjectURL(attachment.data.previewBlobUrl);
    });
};
const $07d6ee757337fb7d$var$updateAttachements = (key, entries, overwrite = false)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
        setState({
            [key]: {
                attachments: new Map([
                    ...!overwrite ? state.attachments.entries() : [],
                    ...entries
                ])
            }
        });
    };
};
const $07d6ee757337fb7d$var$store = (0, $1P1Tu.createStore)({
    name: 'conversationAttachments',
    initialState: {},
    actions: {
        addFiles: (key, files, sendAnalyticsEvent)=>({ getState: _getState, dispatch: dispatch })=>{
                const needsPreview = (file)=>file.fileObject && ((0, $cgmTK.looksLikeImage)(file.fileObject) || (0, $auPMn.isTextFile)(file.fileObject.type, file.fileObject.name));
                // Add files with preview loading state if needed
                const fileAttachments = files.map((file)=>[
                        file.name,
                        {
                            type: 'file',
                            data: needsPreview(file) ? {
                                ...file,
                                isPreviewLoading: true
                            } : file
                        }
                    ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, fileAttachments));
                files.forEach((file)=>{
                    if (needsPreview(file) && file.fileObject) (0, $cgmTK.generateFilePreview)(file.fileObject).then((previewBlobUrl)=>{
                        // Check if file still exists and wasn't removed/errored during preview generation
                        const currentState = _getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                        const currentAttachment = currentState.attachments.get(file.name);
                        if (!currentAttachment || currentAttachment.type !== 'file' || currentAttachment.data.error) {
                            // File was removed or errored while preview was generating, cleanup the blob
                            URL.revokeObjectURL(previewBlobUrl);
                            return;
                        }
                        dispatch($07d6ee757337fb7d$var$store.actions.updateFileWithName(key, file.name, {
                            previewBlobUrl: previewBlobUrl,
                            isPreviewLoading: false
                        }));
                    }).catch((error)=>{
                        // Log error to Sentry for monitoring
                        (0, $1yaYZ.logException)({
                            exception: error,
                            name: 'file-preview-generation-error',
                            tags: {
                                fileType: file.fileObject?.type
                            }
                        });
                        sendAnalyticsEvent({
                            action: 'failed',
                            actionSubject: 'preview',
                            actionSubjectId: 'thumbnailGeneration',
                            attributes: {
                                fileType: file.fileObject?.type || 'unknown'
                            }
                        });
                        dispatch($07d6ee757337fb7d$var$store.actions.updateFileWithName(key, file.name, {
                            isPreviewLoading: false,
                            previewError: error instanceof Error ? error.message : String(error)
                        }));
                    });
                });
            },
        addExternalContext: (key, context)=>({ getState: _getState, dispatch: dispatch })=>{
                const externalContextAttachments = context.map((context)=>[
                        context.key,
                        {
                            type: 'external',
                            data: context
                        }
                    ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, externalContextAttachments));
            },
        updateFileWithName: (key, fileName, fileData)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                const attachment = currentAttachtments.get(fileName);
                if (attachment && attachment.type === 'file') dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    [
                        fileName,
                        {
                            ...attachment,
                            data: {
                                ...attachment.data,
                                ...fileData
                            }
                        }
                    ]
                ]));
            },
        removeFile: (key, fileName)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup blob URL before removing
                const attachment = currentAttachtments.get(fileName);
                if (attachment) $07d6ee757337fb7d$var$cleanupBlobUrls([
                    attachment
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([entryKey, value])=>value.type !== 'file' || entryKey !== fileName), true));
            },
        removeExternalContext: (key, id)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([entryKey, value])=>value.type !== 'external' || entryKey !== id), true));
            },
        clearFiles: (key)=>({ dispatch: dispatch, getState: getState })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup all file blob URLs
                $07d6ee757337fb7d$var$cleanupBlobUrls([
                    ...currentAttachtments.values()
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([_, value])=>value.type !== 'file'), true));
            },
        clearAttachments: (key)=>({ dispatch: dispatch, getState: getState })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup all blob URLs
                $07d6ee757337fb7d$var$cleanupBlobUrls([
                    ...currentAttachtments.values()
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [], true));
            }
    }
});
const $07d6ee757337fb7d$export$c0d6d7bef4e6e587 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store);
const $07d6ee757337fb7d$export$c07f930e4d0c507 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || $07d6ee757337fb7d$var$defaultStateContextPerKey.attachments.values()
        ]
});
const $07d6ee757337fb7d$export$7d10ab840754c21b = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ].filter((item)=>item.type === 'file').map((item)=>item.data) || []
});
const $07d6ee757337fb7d$export$cffce0bcbf2f13f8 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ]?.filter((item)=>item.type === 'external')?.map((item)=>item.data) || []
});
module.exports["useAllAttachmentsStore"] = $07d6ee757337fb7d$export$c07f930e4d0c507;
module.exports["useFileAttachmentsStore"] = $07d6ee757337fb7d$export$7d10ab840754c21b;
module.exports["useExternalContextsStore"] = $07d6ee757337fb7d$export$cffce0bcbf2f13f8;

});

parcelRegister("auPMn", function(module, exports) {
/**
 * MIME types that should be treated as text files for preview generation.
 * Includes plain text, code files, markup, and structured data formats.
 */ const $2326faffe1b678ce$var$TEXT_MIME_TYPES = [
    'text/',
    'application/json',
    'application/xml',
    'application/x-yaml',
    'application/javascript',
    'application/typescript',
    'application/x-sh'
];
/**
 * File extensions that should be treated as text files.
 * Used as fallback when MIME type is not recognized by the browser.
 */ const $2326faffe1b678ce$var$TEXT_EXTENSIONS = [
    '.txt',
    '.md',
    '.markdown',
    '.json',
    '.xml',
    '.yaml',
    '.yml',
    '.js',
    '.jsx',
    '.ts',
    '.tsx',
    '.css',
    '.scss',
    '.less',
    '.html',
    '.htm',
    '.csv',
    '.log',
    '.sh',
    '.bash',
    '.py',
    '.rb',
    '.java',
    '.c',
    '.cpp',
    '.h',
    '.go',
    '.rs',
    '.sql'
];
function $2326faffe1b678ce$export$689bea3eece53c0e(mimeType, fileName) {
    // First check MIME type
    if (mimeType && $2326faffe1b678ce$var$TEXT_MIME_TYPES.some((type)=>mimeType.startsWith(type))) return true;
    // Fallback to extension check if MIME type is empty or unrecognized
    if (fileName) {
        const lowerFileName = fileName.toLowerCase();
        return $2326faffe1b678ce$var$TEXT_EXTENSIONS.some((ext)=>lowerFileName.endsWith(ext));
    }
    return false;
}
module.exports["isTextFile"] = $2326faffe1b678ce$export$689bea3eece53c0e;

});

parcelRegister("cgmTK", function(module, exports) {

var $auPMn = parcelRequire("auPMn");

/**
 * Generates a thumbnail blob URL from a text-based file by rendering the first few lines to canvas.
 * Supports plain text, markdown, JSON, YAML, XML, code files, etc.
 *
 * @param file - Text file to generate thumbnail from
 * @returns Promise resolving to blob URL
 * @throws Error if thumbnail generation fails or if called in SSR context
 */ async function $7736c958fbea66e5$export$fa096b217fa924a6(file) {
    if (typeof window === 'undefined' || typeof document === 'undefined') throw new Error('Text thumbnail generation requires browser environment');
    // Read first 1000 characters of the file
    const text = await file.slice(0, 1000).text();
    const lines = text.split('\n').slice(0, 12); // First 12 lines for preview
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas 2D context unavailable');
    const width = 200;
    const height = 200;
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, width, height);
    const fontSize = 10;
    const lineHeight = 14;
    const padding = 8;
    context.fillStyle = '#172B4D';
    context.font = `${fontSize}px SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`;
    context.textBaseline = 'top';
    lines.forEach((line, index)=>{
        const y = padding + index * lineHeight;
        if (y + lineHeight > height - padding) return;
        // Truncate line if too long
        const maxWidth = width - padding * 2;
        let displayText = line;
        if (context.measureText(line).width > maxWidth) {
            // Truncate and add ellipsis
            while(context.measureText(displayText + '...').width > maxWidth && displayText.length > 0)displayText = displayText.slice(0, -1);
            displayText += '...';
        }
        context.fillText(displayText, padding, y);
    });
    // Add subtle border
    context.strokeStyle = '#DFE1E6';
    context.lineWidth = 1;
    context.strokeRect(0, 0, width, height);
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(URL.createObjectURL(blob));
            else reject(new Error('Failed to generate blob from canvas'));
        }, 'image/png');
    });
}


const $623c39f9ecbb03e8$export$7f2965a86780a5f1 = new Set([
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'svg',
    'bmp',
    'ico',
    'avif'
]);
function $623c39f9ecbb03e8$export$b7ba222ba9a0eb12(fileObject) {
    if (fileObject.type.startsWith('image/')) return true;
    // Some browsers/OS don't set MIME on screenshots — fall back to extension.
    const ext = fileObject.name.split('.').pop()?.toLowerCase() ?? '';
    return $623c39f9ecbb03e8$export$7f2965a86780a5f1.has(ext);
}
async function $623c39f9ecbb03e8$export$905085f77a7184a2(fileObject) {
    if ($623c39f9ecbb03e8$export$b7ba222ba9a0eb12(fileObject)) try {
        return URL.createObjectURL(fileObject);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Failed to create blob URL for image file';
        throw new Error(`Failed to create blob URL for image: ${errorMessage}`);
    }
    else if ((0, $auPMn.isTextFile)(fileObject.type, fileObject.name)) return await (0, $7736c958fbea66e5$export$fa096b217fa924a6)(fileObject);
    throw new Error(`Unsupported file type: ${fileObject.type}`);
}
module.exports["looksLikeImage"] = $623c39f9ecbb03e8$export$b7ba222ba9a0eb12;
module.exports["generateFilePreview"] = $623c39f9ecbb03e8$export$905085f77a7184a2;

});

parcelRegister("3X525", function(module, exports) {
const $d93391a18568f80b$export$4b24e3a88bb9f9d0 = 10;
const $d93391a18568f80b$export$62220f2257a1b032 = 20971520; // 20MB
const $d93391a18568f80b$export$b39af14b910b9848 = 104857600; // 100MB
module.exports["MAX_FILES"] = $d93391a18568f80b$export$4b24e3a88bb9f9d0;

});

parcelRegister("fbZF8", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4wH3g = parcelRequire("4wH3g");


var $fBMbo = parcelRequire("fBMbo");


var $1qfLF = parcelRequire("1qfLF");


var $c6GJD = parcelRequire("c6GJD");


var $x4n5k = parcelRequire("x4n5k");


var $k7vXL = parcelRequire("k7vXL");


var $bKhxF = parcelRequire("bKhxF");


var $g5gZt = parcelRequire("g5gZt");


var $hmuev = parcelRequire("hmuev");


var $1bY7o = parcelRequire("1bY7o");


var $b4wUN = parcelRequire("b4wUN");


var $8jHAi = parcelRequire("8jHAi");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");




const $482d2b6a189b000d$export$b9bd19bdeffb47f1 = ({ contextProviders: contextProviders = [], onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable } = {})=>{
    const [currentBrowser, setCurrentBrowser] = (0, $42omo.useState)(null);
    const [currentContexts, setCurrentContexts] = (0, $42omo.useState)([]);
    const handleShowContextBrowser = (0, $42omo.useCallback)((browser)=>{
        setCurrentBrowser(browser);
        onContextBrowserShow?.(browser);
    }, [
        onContextBrowserShow
    ]);
    const handlePromptInputContextAvailable = (0, $42omo.useCallback)((contexts)=>{
        const contextMap = new Map();
        // add existing contexts first
        currentContexts.forEach((context)=>{
            contextMap.set(context.key, context);
        });
        // add/override with new contexts
        contexts.forEach((context)=>{
            contextMap.set(context.key, context);
        });
        const updatedContexts = Array.from(contextMap.values());
        setCurrentContexts(updatedContexts);
        onContextAvailable?.(updatedContexts);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    const getMenuItems = (0, $42omo.useCallback)(()=>{
        return contextProviders.map((provider)=>provider.getMenuItem(handleShowContextBrowser, handlePromptInputContextAvailable)).filter((item)=>item !== null);
    }, [
        contextProviders,
        handleShowContextBrowser,
        handlePromptInputContextAvailable
    ]);
    const clearContexts = (0, $42omo.useCallback)(()=>{
        setCurrentContexts([]);
        onContextAvailable?.([]);
    }, [
        onContextAvailable
    ]);
    const removeContext = (0, $42omo.useCallback)((contextKey)=>{
        const updatedContexts = currentContexts.filter((context)=>context.key !== contextKey);
        setCurrentContexts(updatedContexts);
        onContextAvailable?.(updatedContexts);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    return {
        currentBrowser: currentBrowser,
        currentContexts: currentContexts,
        getMenuItems: getMenuItems,
        clearContexts: clearContexts,
        removeContext: removeContext,
        setCurrentBrowser: setCurrentBrowser
    };
};



var $kIvLT = parcelRequire("kIvLT");


var $5VZ9F = parcelRequire("5VZ9F");


var $i1Nyn = parcelRequire("i1Nyn");


var $7qwOJ = parcelRequire("7qwOJ");


var $6Y7nw = parcelRequire("6Y7nw");


var $4xY4H = parcelRequire("4xY4H");


var $ipUai = parcelRequire("ipUai");


var $PRMv4 = parcelRequire("PRMv4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $hw7wB = parcelRequire("hw7wB");











var $3X525 = parcelRequire("3X525");


var $5Bdam = parcelRequire("5Bdam");




const $5c181fafcb8735e6$var$message = (0, $aXWIB.defineMessages)({
    fileUploadButtonLabel: {
        id: "rovo-chat.file-upload-button.label",
        defaultMessage: "Upload file"
    },
    fileUploadButtonMaxFilesLabel: {
        id: "rovo-chat.file-upload-button.max-files-label",
        defaultMessage: "Limit of {maxFiles, plural, one {# file} other {# files}} reached"
    }
});
var $5c181fafcb8735e6$export$2e2bcd8739ae039 = $5c181fafcb8735e6$var$message;


const $f9254ba572c994ce$export$8fc396871921c53a = ({ onClick: onClick, assistanceServiceParams: assistanceServiceParams, attachmentsStoreKey: attachmentsStoreKey })=>{
    (0, $fBMbo.di)((0, $6Y7nw.useConversationFiles));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { files: files } = (0, $6Y7nw.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParams,
            touchpointSource: 'fileUploadButton'
        },
        key: attachmentsStoreKey
    });
    const isMaxFilesReached = files.length >= (0, $3X525.MAX_FILES);
    const handleClick = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatFileUploadButton'
        });
        onClick();
    };
    const menuItem = /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
            label: ""
        }),
        label: formatMessage((0, $5c181fafcb8735e6$export$2e2bcd8739ae039).fileUploadButtonLabel),
        isDisabled: isMaxFilesReached,
        onClick: handleClick,
        testId: "file-upload-dropdown-item"
    }); // Wrap with tooltip when disabled to show the max files message
    if (isMaxFilesReached) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $5c181fafcb8735e6$export$2e2bcd8739ae039).fileUploadButtonMaxFilesLabel, {
            maxFiles: (0, $3X525.MAX_FILES)
        }),
        children: menuItem
    });
    return menuItem;
};








const $2f9581b1028ef545$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    createSpaceButtonLabel: {
        id: "ai-mate.chat-input.create-space-button.label",
        defaultMessage: "Create space"
    },
    chatInputActionsButtonsTooltip: {
        id: "ai-mate.chat-input.open-chat-input-buttons-tooltip",
        defaultMessage: "Add"
    },
    mentionTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.mention-type-ahead-button.label",
        defaultMessage: "Mention someone"
    },
    linkTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.link-type-ahead-button.label",
        defaultMessage: "Add a link"
    },
    addContentButtonLabel: {
        id: "ai-mate.chat-input.add-content-button.label",
        defaultMessage: "Use what you're viewing as context"
    },
    addMoreFormattingButtonLabel: {
        id: "ai-mate.chat-input.add-more-formatting-button.label",
        defaultMessage: "More formatting"
    },
    addCurrentPageAsContextDisabledTooltip: {
        id: "ai-mate.chat-input.add-current-page-as-context-disabled-tooltip",
        defaultMessage: "This page isn't supported yet"
    },
    discoverSkillsButtonLabel: {
        id: "ai-mate.chat-input.discover-skills-button.label",
        defaultMessage: "View all skills"
    },
    discoverSkillsButtonDisabledTooltip: {
        id: "ai-mate.chat-input.discover-skills-button.disabled-tooltip",
        defaultMessage: "You're already using a skill"
    },
    browsePromptLibraryButtonLabel: {
        id: "ai-mate.chat-input.browse-prompt-library-button.label",
        defaultMessage: "Browse prompt library"
    },
    browsePromptLibraryNewBadge: {
        id: "ai-mate.chat-input.browse-prompt-library-button.new-badge",
        defaultMessage: "New"
    }
});



const $cd4abe94a6566bf9$var$LoadableAgentSection = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "ehGv6",
    name: "LoadableAgentSection",
    loader: async ()=>(await (parcelRequire("7FMGC"))).AgentSection,
    loading: ()=>null
});

const $cd4abe94a6566bf9$var$LoadableRecommendedAgentsPreloader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xlnjp",
    name: "LoadableRecommendedAgentsPreloader",
    loader: async ()=>(await (parcelRequire("bmYrO"))).RecommendedAgentsPreloader,
    loading: ()=>null
});

const $cd4abe94a6566bf9$var$LazyAgentSection = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7FMGC")).then((module)=>{
        return {
            default: module.AgentSection
        };
    }));

const $cd4abe94a6566bf9$var$LazyRecommendedAgentsPreloader = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bmYrO")).then((module)=>{
        return {
            default: module.RecommendedAgentsPreloader
        };
    }));
const $cd4abe94a6566bf9$var$styles = {
    menuContainer: "_zulp1b66 _1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _2lx21bp4 _4cvr1fhb _bfhkvuon _1ul9p3fh _p12f1mjv",
    menuSection: "_zulpv77o _1e0c1txw _2lx21bp4",
    sectionHeader: "_11c8i4vh _18zru2gc _1rjc12x7 _syaz1rpy",
    divider: "_1mou12x7 _4t3it94y _bfhksm61",
    menuPopupContainer: "_2rko1mok _19itia51 _1reo15vq _18m915vq _16qs130s _1pbyni7l",
    newLozengeBadge: "_18zr1b66 _1e0c1txw _4cvr1y6m"
};
const $cd4abe94a6566bf9$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ...props,
        ref: ref,
        xcss: $cd4abe94a6566bf9$var$styles.menuPopupContainer,
        "data-testid": undefined
    }));
const $cd4abe94a6566bf9$export$8a4234462d786b48 = ({ entryPoint: entryPoint, siteId: siteId, useCurrentPageContext: useCurrentPageContext, onLinkTypeAheadClick: onLinkTypeAheadClick, onMentionTypeAheadClick: onMentionTypeAheadClick, onAddTypeAheadClick: onAddTypeAheadClick, onDiscoverSkillsClick: onDiscoverSkillsClick, onBrowsePromptLibraryClick: onBrowsePromptLibraryClick, onCreateSpaceClick: onCreateSpaceClick, hasSkillInPrompt: hasSkillInPrompt = false, assistanceServiceParams: assistanceServiceParams, fileUploadAssistanceOverrides: fileUploadAssistanceOverrides, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, isDisabled: isDisabled, placement: placement = 'top-start', attachmentsAndCurrentPageAsContextStoreKey: attachmentsStoreAndCurrentPageContextKey, onMenuOpen: onMenuOpen, onAgentSelect: onAgentSelect, isBrowseAgentsModalOpen: isBrowseAgentsModalOpen = false, setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen = ()=>{}, shouldRenderInPortal: shouldRenderInPortal = false, enableBrowserContextBanner: enableBrowserContextBanner = false, browserContextSanitizer: browserContextSanitizer, menuItemsVisibility: externalMenuItemsVisibility = {} })=>{
    const menuItemsVisibility = {
        fileUpload: externalMenuItemsVisibility?.fileUpload ?? true,
        mention: externalMenuItemsVisibility?.mention ?? true,
        format: externalMenuItemsVisibility?.format ?? true,
        link: externalMenuItemsVisibility?.link ?? true
    }; // If every controllable menu item is explicitly hidden, don't render the trigger button at all.
    const hasAnyVisibleItem = Object.values(menuItemsVisibility).some(Boolean);
    (0, $fBMbo.di)((0, $PRMv4.useCurrentPageAsContext), (0, $6Y7nw.useConversationFiles), (0, $i1Nyn.useChatContextBrowserContext));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { setUseCurrentPageContextUserPreference: setUseCurrentPageContextUserPreference, currentContext: currentContext } = (0, $PRMv4.useCurrentPageAsContext)();
    const [browserContext] = (0, $i1Nyn.useChatContextBrowserContext)();
    const showAddContextButton = useCurrentPageContext; // Only consider browser context available if enableBrowserContextBanner config is enabled (otherwise behave as non-extension)
    const hasBrowserContext = !!browserContext?.context?.browserUrl && enableBrowserContextBanner; // Check if browser context URL is blocklisted (only when enableBrowserContextBanner is true and sanitizer is provided)
    const isBrowserContextBlocklisted = enableBrowserContextBanner && browserContextSanitizer && hasBrowserContext && browserContext?.context?.browserUrl ? browserContextSanitizer.isBlocklisted(browserContext.context.browserUrl) : false; // Button should be disabled only if:
    // 1. Current context type is 'none' (page not supported)
    // 2. AND no browser context is available (can't use external site context)
    // If browser context is available, enable the button even if currentContext.type === 'none' (unless blocklisted)
    const isContextDisabled = isBrowserContextBlocklisted || currentContext.type === 'none' && !hasBrowserContext;
    const [menuState, setMenuState] = (0, $42omo.useState)('main');
    const [currentContextBrowser, setCurrentContextBrowser] = (0, $42omo.useState)(null);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const { addExternalContext: addExternalContext } = (0, $7qwOJ.useConversationExternalAttachments)(attachmentsStoreAndCurrentPageContextKey);
    const returnFocusRef = (0, $42omo.useRef)(null);
    const assistanceServiceParamsForFileUpload = (0, $42omo.useMemo)(()=>({
            ...assistanceServiceParams,
            ...fileUploadAssistanceOverrides ?? {}
        }), [
        assistanceServiceParams,
        fileUploadAssistanceOverrides
    ]);
    const inputRef = (0, $42omo.useRef)(null);
    const { getFileInput: getFileInput } = (0, $6Y7nw.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParamsForFileUpload,
            touchpointSource: 'chatInputActionButtons'
        },
        key: attachmentsStoreAndCurrentPageContextKey
    });
    const { getMenuItems: getMenuItems } = (0, $482d2b6a189b000d$export$b9bd19bdeffb47f1)({
        contextProviders: contextProviders,
        onContextBrowserShow: (browser)=>{
            if (browser) {
                setCurrentContextBrowser(browser);
                setMenuState('external-context');
            } else {
                setCurrentContextBrowser(null);
                setMenuState('main');
            }
            onContextBrowserShow?.(browser);
        },
        onContextAvailable: (contexts)=>{
            setMenuState('main');
            setCurrentContextBrowser(null);
            setIsDropdownOpen(false); // Add external contexts to unified store
            addExternalContext(attachmentsStoreAndCurrentPageContextKey, contexts);
            onContextAvailable?.(contexts);
        }
    });
    const focusOnClose = (event)=>{
        // Refocus on the trigger when closing the popup except for native mouse events
        if (!event || event.detail === 0) requestAnimationFrame(()=>{
            returnFocusRef?.current?.focus();
        });
    };
    const externalMenuItems = getMenuItems(); // Hide the entire trigger button when every controllable menu item is turned off.
    // All hooks are called above unconditionally (rules of hooks). The early return is
    // safe here because it comes after all hook calls.
    // Note: externalMenuItems (3rd-party context providers) are not counted here because
    // they are dynamic; the consumer controls visibility via menuItemsVisibility only.
    if (!hasAnyVisibleItem) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: isDropdownOpen,
                onClose: ()=>{
                    setIsDropdownOpen(false);
                    setMenuState('main');
                    setCurrentContextBrowser(null);
                    focusOnClose();
                },
                placement: placement,
                shouldRenderToParent: !shouldRenderInPortal,
                shouldFlip: !shouldRenderInPortal,
                popupComponent: $cd4abe94a6566bf9$var$PopupComponent,
                zIndex: (0, $dh538.fg)('platform-dst-motion-uplift-popup') ? 600 : (0, $dh538.fg)('global_rovo_button_in_jira') ? 600 : undefined,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5VZ9F.GettingStartedTourSpotlight), {
                        step: 1,
                        entryPoint: entryPoint,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            onClick: (e, analyticsEvent)=>{
                                sendAnalyticsEvent(analyticsEvent.update({
                                    actionSubjectId: 'rovoChatAddMenuTrigger'
                                }));
                                setIsDropdownOpen(!isDropdownOpen);
                                if (!isDropdownOpen) onMenuOpen?.();
                            },
                            isTooltipDisabled: false,
                            isSelected: isDropdownOpen,
                            appearance: "subtle",
                            icon: isDropdownOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                            label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).chatInputActionsButtonsTooltip),
                            ref: (0, $4xY4H.default)([
                                triggerProps.ref,
                                returnFocusRef
                            ]),
                            isDisabled: isDisabled
                        })
                    }),
                content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        role: "menu",
                        xcss: $cd4abe94a6566bf9$var$styles.menuContainer,
                        children: [
                            menuState === 'main' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                        xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                        role: "group",
                                        children: [
                                            onCreateSpaceClick && (0, $dh538.fg)('rovo_chat_spaces_fe') && /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k7vXL))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).createSpaceButtonLabel),
                                                onClick: ()=>{
                                                    onCreateSpaceClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatCreateSpaceButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            onBrowsePromptLibraryClick && (0, $c6GJD.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) && /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).browsePromptLibraryButtonLabel),
                                                onClick: ()=>{
                                                    (0, $42omo.startTransition)(()=>{
                                                        onBrowsePromptLibraryClick();
                                                    });
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'libraryOpenedFromSidebar',
                                                        attributes: {
                                                            source: 'browseInputMenuButton'
                                                        }
                                                    });
                                                    setIsDropdownOpen(false);
                                                },
                                                badge: (0, $dh538.fg)('rovo_chat_prompt_library_new_badge') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $cd4abe94a6566bf9$var$styles.newLozengeBadge,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                                        appearance: "new",
                                                        children: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).browsePromptLibraryNewBadge)
                                                    })
                                                }) : undefined
                                            }),
                                            (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1') && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                                children: onDiscoverSkillsClick && (0, $dh538.fg)('rovo_skills_directory_ui') && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    position: "top",
                                                    content: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).discoverSkillsButtonDisabledTooltip),
                                                    canAppear: ()=>hasSkillInPrompt,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bKhxF))), {
                                                            label: ""
                                                        }),
                                                        label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).discoverSkillsButtonLabel),
                                                        isDisabled: hasSkillInPrompt,
                                                        onClick: ()=>{
                                                            (0, $42omo.startTransition)(()=>{
                                                                onDiscoverSkillsClick();
                                                            });
                                                            sendAnalyticsEvent({
                                                                action: 'clicked',
                                                                actionSubject: 'button',
                                                                actionSubjectId: 'rovoChatDiscoverSkillsButton'
                                                            });
                                                            setIsDropdownOpen(false);
                                                        }
                                                    })
                                                })
                                            }),
                                            menuItemsVisibility.fileUpload && /*#__PURE__*/ (0, $l998X.jsx)((0, $f9254ba572c994ce$export$8fc396871921c53a), {
                                                attachmentsStoreKey: attachmentsStoreAndCurrentPageContextKey,
                                                onClick: ()=>{
                                                    inputRef.current?.click();
                                                    setIsDropdownOpen(false);
                                                },
                                                assistanceServiceParams: assistanceServiceParamsForFileUpload
                                            }),
                                            menuItemsVisibility.link && /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).linkTypeAheadButtonLabel),
                                                onClick: ()=>{
                                                    onLinkTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatAddLinkButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            externalMenuItems.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                    icon: item.icon,
                                                    label: item.label,
                                                    onClick: ()=>{
                                                        item.action();
                                                        sendAnalyticsEvent({
                                                            action: 'clicked',
                                                            actionSubject: 'button',
                                                            actionSubjectId: `rovoChatExternalContext_${item.key}`
                                                        });
                                                    }
                                                }, item.key)),
                                            menuItemsVisibility.mention && /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).mentionTypeAheadButtonLabel),
                                                onClick: ()=>{
                                                    onMentionTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatMentionButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            menuItemsVisibility.format && /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addMoreFormattingButtonLabel),
                                                onClick: ()=>{
                                                    onAddTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatAddFormattingButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            showAddContextButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                position: "top",
                                                content: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addCurrentPageAsContextDisabledTooltip),
                                                canAppear: ()=>isContextDisabled,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                                        label: ""
                                                    }),
                                                    label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addContentButtonLabel),
                                                    isDisabled: isContextDisabled,
                                                    onClick: ()=>{
                                                        setUseCurrentPageContextUserPreference(attachmentsStoreAndCurrentPageContextKey, true);
                                                        sendAnalyticsEvent({
                                                            action: 'clicked',
                                                            actionSubject: 'button',
                                                            actionSubjectId: 'rovoChatAddContextButton'
                                                        });
                                                        setIsDropdownOpen(false);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    onAgentSelect && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.divider
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.sectionHeader,
                                                children: formatMessage((0, $ipUai.messages).agentsHeader)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                                role: "group",
                                                children: (0, $dh538.fg)('aimate_conversation_assistant_async_loading') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                                    fallback: null,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$LazyAgentSection, {
                                                        assistanceServiceParams: assistanceServiceParams,
                                                        onAgentSelect: onAgentSelect,
                                                        siteId: siteId,
                                                        isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                                                        setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                                                        setIsDropdownOpen: setIsDropdownOpen
                                                    })
                                                }) : /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$LoadableAgentSection, {
                                                    assistanceServiceParams: assistanceServiceParams,
                                                    onAgentSelect: onAgentSelect,
                                                    siteId: siteId,
                                                    isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                                                    setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                                                    setIsDropdownOpen: setIsDropdownOpen
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            menuState === 'external-context' && currentContextBrowser && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                role: "group",
                                children: currentContextBrowser
                            })
                        ]
                    }),
                shouldUseCaptureOnOutsideClick: true
            }),
            menuItemsVisibility.fileUpload && getFileInput(inputRef),
            onAgentSelect && /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$AgentSectionPreloader, {
                assistanceServiceParams: assistanceServiceParams
            })
        ]
    });
};
const $cd4abe94a6566bf9$var$AgentSectionPreloader = ({ assistanceServiceParams: assistanceServiceParams })=>{
    // Preload the bundle
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('aimate_conversation_assistant_async_loading')) $cd4abe94a6566bf9$var$LoadableAgentSection.preload();
    }, []); // Preload the data
    if ((0, $dh538.fg)('aimate_conversation_assistant_async_loading')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$LazyRecommendedAgentsPreloader, {
            assistanceServiceParams: assistanceServiceParams
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$LoadableRecommendedAgentsPreloader, {
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["ChatInputActionButtons"] = $cd4abe94a6566bf9$export$8a4234462d786b48;

});

parcelRegister("k7vXL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e35b63587604b83f78044d9ad52be8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea5d413ebf4151ca$var$_react = $ea5d413ebf4151ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $ea5d413ebf4151ca$var$_baseNew = $ea5d413ebf4151ca$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ea5d413ebf4151ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderAdd".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea5d413ebf4151ca$var$FolderAddIcon = (props)=>/*#__PURE__*/ $ea5d413ebf4151ca$var$_react.default.createElement($ea5d413ebf4151ca$var$_baseNew.default, Object.assign({
        name: "FolderAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V7.5H2.5V13a.5.5 0 0 0 .5.5h4.5V15H3a2 2 0 0 1-2-2m1.5-7h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5H3a.5.5 0 0 0-.5.5z"/><path fill="currentcolor" d="M13.75 10v2.25H16v1.5h-2.25V16h-1.5v-2.25H10v-1.5h2.25V10z"/>`
    }, props));
$ea5d413ebf4151ca$var$FolderAddIcon.displayName = 'FolderAddIcon';
var $ea5d413ebf4151ca$var$_default = module.exports.default = $ea5d413ebf4151ca$var$FolderAddIcon;

});

parcelRegister("bKhxF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a094e46648e7c203d266148a7c03a503>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88d19910bc6e79fa$var$_react = $88d19910bc6e79fa$var$_interopRequireDefault((parcelRequire("42omo")));

var $88d19910bc6e79fa$var$_baseNew = $88d19910bc6e79fa$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $88d19910bc6e79fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Skill".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88d19910bc6e79fa$var$SkillIcon = (props)=>/*#__PURE__*/ $88d19910bc6e79fa$var$_react.default.createElement($88d19910bc6e79fa$var$_baseNew.default, Object.assign({
        name: "SkillIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="m11.11 4.934-5 7-1.22-.871 5-7z"/>`
    }, props));
$88d19910bc6e79fa$var$SkillIcon.displayName = 'SkillIcon';
var $88d19910bc6e79fa$var$_default = module.exports.default = $88d19910bc6e79fa$var$SkillIcon;

});

parcelRegister("5VZ9F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $kIvLT = parcelRequire("kIvLT");


var $7tmqn = parcelRequire("7tmqn");




const $5c80665022c6e61d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    back: {
        id: "ai-mate.getting-started-tour.back",
        defaultMessage: "Back"
    },
    done: {
        id: "ai-mate.getting-started-tour.done",
        defaultMessage: "Done"
    },
    next: {
        id: "ai-mate.getting-started-tour.next",
        defaultMessage: "Next"
    },
    stepIndicator: {
        id: "ai-mate.getting-started-tour.indicator",
        defaultMessage: "{stepNumber} of {totalSteps}"
    },
    stepOneTitle: {
        id: "ai-mate.getting-started-tour.step-one.title",
        defaultMessage: "Add work from anywhere"
    },
    stepOneDescription: {
        id: "ai-mate.getting-started-tour.step-one.description",
        defaultMessage: "Choose a template, upload a file, link a page, and more to power your creation."
    },
    stepTwoTitle: {
        id: "ai-mate.getting-started-tour.step-two.title",
        defaultMessage: "Get unstuck on your prompt"
    },
    stepTwoDescription: {
        id: "ai-mate.getting-started-tour.step-two.description",
        defaultMessage: "Try an example or use them to jump-start your draft."
    },
    stepThreeTitle: {
        id: "ai-mate.getting-started-tour.step-three.title",
        defaultMessage: "Talk to Rovo instead of typing"
    },
    stepThreeDescription: {
        id: "ai-mate.getting-started-tour.step-three.description",
        defaultMessage: "Use your voice to get started."
    }
});


const $5c04011d7aad6cfe$var$stepConfig = [
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepOneTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepOneDescription,
        placement: 'bottom-start'
    },
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepTwoTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepTwoDescription,
        placement: 'left-start'
    },
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepThreeTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepThreeDescription,
        placement: 'bottom-end'
    }
];
const $5c04011d7aad6cfe$var$ALLOWED_ENTRY_POINT = '-smartCreate';
const $5c04011d7aad6cfe$export$187fca2312a637a5 = ({ entryPoint: entryPoint, children: children, step: step })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { stepNumber: currentStepNumber, totalSteps: totalSteps } = (0, $7tmqn.useGettingStartedTourState)();
    const { setStepNumber: hideGettingStartedSpotlightTour, nextStep: moveToNextStep, previousStep: moveToPreviousStep, dismiss: completeGettingStartedTour } = (0, $7tmqn.useGettingStartedTourStoreActions)();
    const handleOnNextClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightPrimaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        if (step === totalSteps) completeGettingStartedTour();
        else moveToNextStep();
    }, [
        step,
        totalSteps,
        completeGettingStartedTour,
        moveToNextStep,
        sendAnalyticsEvent
    ]);
    const handleOnPreviousClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightSecondaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        moveToPreviousStep();
    }, [
        step,
        moveToPreviousStep,
        sendAnalyticsEvent
    ]);
    const handleOnDismissClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightDismissButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        hideGettingStartedSpotlightTour(0);
    }, [
        step,
        hideGettingStartedSpotlightTour,
        sendAnalyticsEvent
    ]);
    if (!(0, $dh538.fg)('platform_aifc_getting_started_spotlight') || !entryPoint?.includes($5c04011d7aad6cfe$var$ALLOWED_ENTRY_POINT)) return children;
    const currentConfig = $5c04011d7aad6cfe$var$stepConfig[step - 1];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $k7Tf7.PopoverProvider), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a90ar.PopoverTarget), {
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
                dismiss: handleOnDismissClicked,
                isVisible: currentStepNumber === step,
                placement: currentConfig?.placement,
                strategy: "absolute",
                children: (()=>{
                    const spotlightCard = /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
                        testId: "spotlight",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                                        children: formatMessage(currentConfig?.title)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                            onClick: handleOnDismissClicked
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                                children: formatMessage(currentConfig?.description)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eopLP.SpotlightFooter), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aG6kF.SpotlightStepCount), {
                                        children: formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepIndicator, {
                                            stepNumber: step,
                                            totalSteps: totalSteps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $3chlW.SpotlightActions), {
                                        children: [
                                            currentStepNumber > 1 && /*#__PURE__*/ (0, $l998X.jsx)((0, $19Jj3.SpotlightSecondaryAction), {
                                                onClick: handleOnPreviousClicked,
                                                children: formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).back)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                                                onClick: handleOnNextClicked,
                                                children: currentStepNumber < totalSteps ? formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).next) : formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).done)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                    return (0, $dh538.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                        entranceDirection: "left",
                        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                                ...props,
                                children: spotlightCard
                            })
                    });
                })()
            })
        ]
    });
};
module.exports["GettingStartedTourSpotlight"] = $5c04011d7aad6cfe$export$187fca2312a637a5;

});

parcelRegister("7tmqn", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $fb2157568c57e2df$var$initialState = {
    stepNumber: 0,
    totalSteps: 3,
    hasDismissed: false,
    hasStarted: false
};
const $fb2157568c57e2df$var$setStepNumber = (step)=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: step
        });
    };
};
const $fb2157568c57e2df$var$nextStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber + 1;
        setState({
            stepNumber: nextStepValue > $fb2157568c57e2df$var$initialState.totalSteps ? 0 : nextStepValue
        });
    };
};
const $fb2157568c57e2df$var$previousStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber - 1;
        setState({
            stepNumber: nextStepValue < 1 ? 1 : nextStepValue
        });
    };
};
const $fb2157568c57e2df$var$resetStep = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 1,
            hasStarted: true
        });
    };
};
const $fb2157568c57e2df$var$dismiss = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 0,
            hasDismissed: true
        });
    };
};
const $fb2157568c57e2df$var$store = (0, $1P1Tu.createStore)({
    initialState: $fb2157568c57e2df$var$initialState,
    actions: {
        setStepNumber: (step)=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$setStepNumber(step));
            },
        nextStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$nextStep());
            },
        previousStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$previousStep());
            },
        resetStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$resetStep());
            },
        dismiss: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$dismiss());
            }
    }
});
const $fb2157568c57e2df$export$892b983d1b41ebe1 = (0, $9zUhf.createHook)($fb2157568c57e2df$var$store);
const $fb2157568c57e2df$export$7170019ae9cc343d = (0, $9zUhf.createActionsHook)($fb2157568c57e2df$var$store);
const $fb2157568c57e2df$export$7d095908422babd2 = ()=>{
    const [state] = $fb2157568c57e2df$export$892b983d1b41ebe1();
    return state;
};
module.exports["useGettingStartedTourStoreActions"] = $fb2157568c57e2df$export$7170019ae9cc343d;
module.exports["useGettingStartedTourState"] = $fb2157568c57e2df$export$7d095908422babd2;

});

parcelRegister("7qwOJ", function(module, exports) {

var $bJOL1 = parcelRequire("bJOL1");

const $7d0343b3409f6bfe$export$ee6324403e0cde6 = (key)=>{
    const [externalContexts, { addExternalContext: addExternalContext }] = (0, $bJOL1.useExternalContextsStore)(key);
    const externalContextsServiceRepresentations = externalContexts.map((context)=>context.serviceRepresentation);
    return {
        addExternalContext: addExternalContext,
        externalContextsServiceRepresentations: externalContextsServiceRepresentations
    };
};
module.exports["useConversationExternalAttachments"] = $7d0343b3409f6bfe$export$ee6324403e0cde6;

});

parcelRegister("4xY4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $d971d809a8e21bf8$export$2e2bcd8739ae039);
function $d971d809a8e21bf8$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("ipUai", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $4eca00df6358d525$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    agentsHeader: {
        id: "ai-mate.chat-input.agents.header",
        defaultMessage: "Start chatting with agents"
    },
    browseAgents: {
        id: "ai-mate.chat-input.agents.browse-agents",
        defaultMessage: "Browse agents"
    },
    createAgent: {
        id: "ai-mate.chat-input.agents.create-agent",
        defaultMessage: "Create agent"
    }
});
module.exports["messages"] = $4eca00df6358d525$export$defe85febe8b728c;

});

parcelRegister("PRMv4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $i1Nyn = parcelRequire("i1Nyn");


var $V9Rzh = parcelRequire("V9Rzh");

var $329c74d7ff3c6273$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["CONFLUENCE_DATABASE"] = "confluence-database";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_BOARD"] = "jira-board-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_SERVICE_DESK"] = "jira-service-desk";
    PageContextType["JIRA_PLAN"] = "jira-plan";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_ITAM_HAM"] = "jira-itam-ham";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_PROJECT"] = "atlas-project";
    PageContextType["ATLAS_GOAL"] = "atlas-goal";
    PageContextType["FEEDBACK_APP"] = "feedback-app";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["TEAM_PROFILE"] = "team-profile";
    PageContextType["USER_PROFILE"] = "user-profile";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $329c74d7ff3c6273$export$46133998910543ac = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $329c74d7ff3c6273$export$6fa751d66e55d2e1 = ()=>{
    const [location, setLocation] = (0, $42omo.useState)(window.location.href);
    // For easier mocking
    const contextValue = (0, $42omo.useContext)($329c74d7ff3c6273$export$46133998910543ac);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (window.location.href !== location) setLocation(window.location.href);
    }, [
        location,
        setLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
var $329c74d7ff3c6273$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["THINKING_VIEW"] = "thinking-view";
    UseCase["AUTOCOMPLETE"] = "autocomplete";
    return UseCase;
}({});
const $329c74d7ff3c6273$var$ALLOWED_PAGE_CONTEXT_TYPES = {
    ["thinking-view"]: [
        "confluence-page-edit",
        "confluence-page-view",
        "confluence-whiteboard",
        "confluence-database",
        "jira-issue-view",
        "jira-service-desk",
        "jira-project",
        "jira-plan",
        "jira-cmp-space-settings-people-legacy",
        "jira-cmp-space-settings-permissions-legacy",
        "jira-itam-ham",
        "atlas-project",
        "atlas-goal",
        "feedback-app",
        "store-home",
        "trello-board",
        "trello-card",
        "team-profile",
        "user-profile"
    ],
    ["autocomplete"]: [
        "bitbucket",
        "confluence-home",
        "confluence-page-edit",
        "confluence-page-view",
        "confluence-whiteboard",
        "confluence-database",
        "jira-backlog",
        "jira-home",
        "jira-issue-view",
        "atlas-home",
        "store-home",
        "trello-board",
        "trello-card"
    ]
};
const $329c74d7ff3c6273$var$FALLBACK_PAGE_CONTEXT_TYPE = {
    ["thinking-view"]: "unknown",
    ["autocomplete"]: "atlas-home"
};
const $329c74d7ff3c6273$export$a905239756c1fbae = (location, useCase = "thinking-view")=>{
    const allowedTypes = new Set($329c74d7ff3c6273$var$ALLOWED_PAGE_CONTEXT_TYPES[useCase]);
    const allUrlPatterns = [
        [
            "bitbucket",
            /bitbucket\.org\/.*/
        ],
        //If flag is on, use confluence page view for confluence home url pattern since model doesn't have enough data for home
        ...useCase === "autocomplete" && (0, $dh538.fg)('rovo_chat_typeahead_use_confluence-page_fallback') ? [
            [
                "confluence-page-view",
                /\/wiki\/home$/
            ]
        ] : [
            [
                "confluence-home",
                /\/wiki\/home$/
            ]
        ],
        [
            "confluence-page-edit",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            "confluence-page-view",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        // Support whiteboard url
        [
            "confluence-whiteboard",
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        // Support whiteboard iframe url
        [
            "confluence-whiteboard",
            /\/whiteboards\/whiteboard\/[^\/\?]+/
        ],
        // Support whiteboard internal url after spa transition
        [
            "confluence-whiteboard",
            /\/whiteboard\/[a-f0-9-]+/
        ],
        // Support database url
        [
            "confluence-database",
            /\/wiki\/spaces\/[^\/]+\/database\//
        ],
        // Support database internal url after spa transition
        [
            "confluence-database",
            /\/database\/[a-f0-9-]+/
        ],
        [
            "jira-backlog",
            /\/jira\/.*\/backlog$/
        ],
        [
            "jira-board-view",
            /\/jira\/.*\/boards\//
        ],
        [
            "jira-issue-view",
            /\/browse\/[^\/]+$/
        ],
        [
            "jira-issue-view",
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            "jira-home",
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            "jira-service-desk",
            /\/jira(?:\/.+)?\/servicedesk\/projects\/.+\/queues\/issue\//
        ],
        [
            "jira-project",
            /\/jira\/.+\/projects\//
        ],
        ...(0, $dh538.fg)('itam_ftw') ? [
            [
                "jira-itam-ham",
                /\/jira\/itam\/ham(\/|$)/
            ]
        ] : [],
        ...(0, $dh538.fg)('rovo_chat_jira_plans_minion') ? [
            [
                "jira-plan",
                /\/jira\/plans\/\d+\//
            ]
        ] : [],
        [
            "jira-home",
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            "jira-cmp-space-settings-people-legacy",
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            "jira-cmp-space-settings-permissions-legacy",
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            "atlas-home",
            /\/(home|team)\./
        ],
        [
            "atlas-project",
            /\/(home|team).+\/project\/ATLAS-/
        ],
        [
            "atlas-goal",
            /\/(home|team).+\/goal\/ATLAS-/
        ],
        // Store and Marketplace surfaces can appear on both internal and production domains.
        [
            "store-home",
            /(?:store\.[^/]*atl-paas\.net|store\.atlassian\.com|mpac\.atlassian\.com)/
        ],
        ...(0, $dh538.fg)('convo_ai_enable_team_url_resolution') ? [
            [
                "team-profile",
                /\/(home|team)\..+\/people\/team/
            ]
        ] : [],
        ...(0, $dh538.fg)('convo_ai_enable_user_profile_url_resolution') ? [
            [
                "user-profile",
                /\/(home|team)\..+\/people\/(?!team)/
            ]
        ] : [],
        [
            "feedback-app",
            /\/feedback-app/
        ],
        // Trello: trello.com and trellis.coffee (enterprise)
        [
            "trello-card",
            /(?:trello\.com|trellis\.coffee)\/c\/[^/]+/
        ],
        [
            "trello-board",
            /(?:trello\.com|trellis\.coffee)\/b\/[^/]+/
        ]
    ];
    const urlPatterns = allUrlPatterns.filter(([type])=>allowedTypes.has(type));
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return $329c74d7ff3c6273$var$FALLBACK_PAGE_CONTEXT_TYPE[useCase];
};
const $329c74d7ff3c6273$export$bc4bf2ff8e40b690 = (useCase = "thinking-view")=>{
    const location = $329c74d7ff3c6273$export$6fa751d66e55d2e1();
    const [pageContextType, setPageContextType] = (0, $42omo.useState)($329c74d7ff3c6273$export$a905239756c1fbae(location, useCase));
    (0, $42omo.useEffect)(()=>{
        setPageContextType($329c74d7ff3c6273$export$a905239756c1fbae(location, useCase));
    }, [
        location,
        useCase
    ]);
    return pageContextType;
};
const $329c74d7ff3c6273$var$JIRA_VIEW_CONTEXT_KEY = 'jira_view_context';
function $329c74d7ff3c6273$var$hasValidJiraViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const selected = Object.getOwnPropertyDescriptor(value, 'selectedIssueIdentifiers')?.value;
    return Array.isArray(selected);
}
const $329c74d7ff3c6273$export$a96e0fbf256603d8 = ()=>{
    const pageContextType = $329c74d7ff3c6273$export$bc4bf2ff8e40b690();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $V9Rzh.useChatModeStoreActions)();
    const [editorContext] = (0, $i1Nyn.useChatContextEditorContext)();
    const [databaseContext] = (0, $i1Nyn.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $i1Nyn.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$329c74d7ff3c6273$var$JIRA_VIEW_CONTEXT_KEY];
    const jiraViewContextData = $329c74d7ff3c6273$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
    let currentContext = {
        type: 'none'
    };
    if (editorContext) // prefer editor context over page context if available
    currentContext = {
        type: 'editor_context',
        payload: editorContext
    };
    else if (databaseContext) currentContext = {
        type: 'database_context',
        selectedElementIds: databaseContext.selectedElementIds ?? []
    };
    else if (jiraViewContextData && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('jira-ai-jira-view-context-in-rovo-chat-experiment', 'isEnabled', false)) currentContext = {
        type: 'jira_view_context',
        payload: jiraViewContextData
    };
    else if (pageContextType !== "unknown") // if no editor context, use page context if available
    currentContext = {
        type: 'current_page',
        pageContextType: pageContextType
    };
    return {
        canUseCurrentPageContextUserPreference: (key)=>{
            return getChatMode(key).useCurrentPageContext;
        },
        setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
        currentContext: currentContext
    };
};
module.exports["PageContextType"] = $329c74d7ff3c6273$export$7f7a6f1c2ab5127;
module.exports["useWindowLocation"] = $329c74d7ff3c6273$export$6fa751d66e55d2e1;
module.exports["UseCase"] = $329c74d7ff3c6273$export$59961d6586ccfd15;
module.exports["usePageContextType"] = $329c74d7ff3c6273$export$bc4bf2ff8e40b690;
module.exports["useCurrentPageAsContext"] = $329c74d7ff3c6273$export$a96e0fbf256603d8;

});

parcelRegister("5Bdam", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $cvXh8 = parcelRequire("cvXh8");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $052T2 = parcelRequire("052T2");


var $h8Wyp = parcelRequire("h8Wyp");

const $9de080f6aa623171$var$styles = {
    menuItem: "_zulp12x7 _2rko1qi0 _18zrutpp _1bsb1osq _1e0c1txw _2lx2vrvc _1tkezwfg _1bah1yb4 _4cvr1h6o _80omtlke _bfhksm61 _irr31dpa _1di6fcek",
    menuItemActive: "_bfhk15s3 _syaz6x5g",
    menuItemDisabled: "_80om13gf _syaz1gmx _tzy42wxo",
    menuItemContent: "_zulp12x7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _1e0c1txw _4cvr1h6o _1ul9idpf",
    menuItemIcon: "_1e0c1txw _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _syazazsu",
    menuItemLabelContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _y3gn1e5h",
    menuItemLabel: "_1reo15vq _18m915vq _1e0c1ule _1bsb1osq _o5721q9c _1bto1l2s"
};
const $9de080f6aa623171$export$2ce376c2cc3355c8 = ({ label: label, icon: icon, onClick: onClick, isActive: isActive, isLoading: isLoading, isDisabled: isDisabled, testId: testId, badge: badge })=>{
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    const textRef = (0, $42omo.useRef)(null);
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current && containerRef.current) {
                const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        label
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($9de080f6aa623171$var$styles.menuItem, isActive && $9de080f6aa623171$var$styles.menuItemActive, isDisabled && $9de080f6aa623171$var$styles.menuItemDisabled),
        onClick: isDisabled ? undefined : onClick,
        "aria-disabled": isDisabled,
        role: "menuitem",
        testId: testId || 'menu-item-container',
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $9de080f6aa623171$var$styles.menuItemContent,
                testId: "menu-item-content",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $9de080f6aa623171$var$styles.menuItemIcon,
                        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h8Wyp.LoadingState), {
                            size: "small",
                            testId: "loading-state"
                        }) : icon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $9de080f6aa623171$var$styles.menuItemLabelContainer,
                        ref: containerRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $052T2.ConditionalTooltip), {
                            withTooltip: showTooltip,
                            content: label,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $9de080f6aa623171$var$styles.menuItemLabel,
                                ref: textRef,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: isActive ? 'color.text.selected' : 'color.text.subtle',
                                    testId: "menu-item-label",
                                    children: label
                                })
                            })
                        })
                    }),
                    badge
                ]
            }),
            isActive && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "checkmark"
            })
        ]
    });
};
module.exports["MenuItem"] = $9de080f6aa623171$export$2ce376c2cc3355c8;

});

parcelRegister("052T2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $67aeb4e4700bfc15$export$d8abb7a1cfbd4b6b = ({ withTooltip: withTooltip, content: content, children: children })=>{
    return withTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: content,
        children: children
    }) : children;
};
module.exports["ConditionalTooltip"] = $67aeb4e4700bfc15$export$d8abb7a1cfbd4b6b;

});

parcelRegister("h8Wyp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $9hlns = parcelRequire("9hlns");

const $22fb140c5a96806b$var$styles = {
    loader: "_4t3i1osq _1bsb1osq"
};
const $22fb140c5a96806b$export$62aa48085237e36f = ({ testId: testId, size: size = 'xlarge' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        alignBlock: 'center',
        alignInline: 'center',
        xcss: $22fb140c5a96806b$var$styles.loader,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: size
        })
    });
};
module.exports["LoadingState"] = $22fb140c5a96806b$export$62aa48085237e36f;

});

parcelRegister("7FMGC", function(module, exports) {

let $596220de209e0993$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $596220de209e0993$var$load("gQg5L"),
    $596220de209e0993$var$load("kbRvk"),
    $596220de209e0993$var$load("byzo1"),
    $596220de209e0993$var$load("7EorR"),
    $596220de209e0993$var$load("jLOHm"),
    $596220de209e0993$var$load("49cor")
]).then(()=>parcelRequire('7Zdh8'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("bmYrO", function(module, exports) {

let $8470a369ffc68856$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8470a369ffc68856$var$load("jLOHm"),
    $8470a369ffc68856$var$load("kbRvk"),
    $8470a369ffc68856$var$load("byzo1"),
    $8470a369ffc68856$var$load("3fdRd")
]).then(()=>parcelRequire('bVuTs'));

});

parcelRegister("eRTWv", function(module, exports) {

var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<f9a4dde0e082fa5e35703adb593a1078>>
 * @relayHash 38e158f41480cd21438d590d297af475
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92f00bd8aeacd303c74abf1deafd512cf7949ed5a110618a10863ef16c0b4ee5
const $ce9f50a5719db74f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldFetch"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v8 = [
        {
            "concreteType": "ConvoAiSkillEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "ConvoAiSkill",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "slashCommand"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "iconKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tags"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "integrationKeys"
                        },
                        {
                            "concreteType": "ConvoAiSkillIntegration",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "cursor"
                }
            ]
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalCount"
        },
        {
            "concreteType": "ConvoAiSkillListMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "anthropicCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "stratusCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDegraded"
                }
            ]
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "convoai_availableSkills",
                            "args": [
                                v4 /*: any*/ 
                            ],
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "__Skills__convoai_availableSkills_connection",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "convoai_availableSkills",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "Skills__convoai_availableSkills",
                            "kind": "LinkedHandle",
                            "name": "convoai_availableSkills"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "92f00bd8aeacd303c74abf1deafd512cf7949ed5a110618a10863ef16c0b4ee5",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "convoai_availableSkills"
                        ]
                    }
                ]
            },
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ce9f50a5719db74f$var$node.hash = "cd43e143b802c128a6088ad9176a5cac";
var $ce9f50a5719db74f$export$2e2bcd8739ae039 = $ce9f50a5719db74f$var$node;


/**
 * @generated SignedSource<<18d0253270fee2e2c851b782379a8817>>
 * @relayHash 5cb3b41c36f2a70543ba17959bde136f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8be0ebf87d62bf7cb9e9a9a77785d60c8eb2ebc320c698c1c7f281971472e141
const $7dd36d4de66cae3d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dimensionIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchKeyword"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "Variable",
        "name": "dimensionIds",
        "variableName": "dimensionIds"
    }, v10 = {
        "kind": "Variable",
        "name": "relevantFor",
        "variableName": "relevantFor"
    }, v11 = {
        "kind": "Variable",
        "name": "searchKeyword",
        "variableName": "searchKeyword"
    }, v12 = {
        "kind": "Variable",
        "name": "surface",
        "variableName": "surface"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "description"
    }, v18 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v20 = {
        "kind": "ScalarField",
        "name": "color"
    }, v21 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "message"
    }, v24 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v25 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v26 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v27 = [
        v14 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "composableEditorChat_GetDirectoryItemsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "graphIntegration_componentDirectoryItems",
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ],
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "__Skills__graphIntegration_componentDirectoryItems_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "tags",
                                                            "plural": true,
                                                            "selections": [
                                                                v19 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "composableEditorChat_GetDirectoryItemsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "tags",
                                                            "plural": true,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v26 /*: any*/ ,
                            "filters": [
                                "dimensionIds",
                                "searchKeyword",
                                "relevantFor",
                                "cloudId",
                                "surface"
                            ],
                            "handle": "connection",
                            "key": "Skills__graphIntegration_componentDirectoryItems",
                            "kind": "LinkedHandle",
                            "name": "graphIntegration_componentDirectoryItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8be0ebf87d62bf7cb9e9a9a77785d60c8eb2ebc320c698c1c7f281971472e141",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "graphIntegration_componentDirectoryItems"
                        ]
                    }
                ]
            },
            "name": "composableEditorChat_GetDirectoryItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7dd36d4de66cae3d$var$node.hash = "342b700f6823ad8436a680ec6b6132fc";
var $7dd36d4de66cae3d$export$2e2bcd8739ae039 = $7dd36d4de66cae3d$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $6qdjm = parcelRequire("6qdjm");


var $e6Iiv = parcelRequire("e6Iiv");


var $dh538 = parcelRequire("dh538");


var $kIvLT = parcelRequire("kIvLT");


var $1yaYZ = parcelRequire("1yaYZ");


var $lGVHb = parcelRequire("lGVHb");

/* SkillsEditorExtension.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $bre0g = parcelRequire("bre0g");


var $c6GJD = parcelRequire("c6GJD");


var $5nBzc = parcelRequire("5nBzc");





var $ij2FZ = parcelRequire("ij2FZ");





var $TwPkE = parcelRequire("TwPkE");


var $d3VBU = parcelRequire("d3VBU");


var $3QWW6 = parcelRequire("3QWW6");


var $eDYF8 = parcelRequire("eDYF8");

const $88d8e842aa349fe5$var$getSkillIcon = (iconName)=>iconName && (0, $d3VBU.skillIcon)[iconName] ? (0, $d3VBU.skillIcon)[iconName] : (0, $d3VBU.defaultIcon);
const $88d8e842aa349fe5$var$SKILL_DESCRIPTION_CHAR_LIMIT = 150;
const $88d8e842aa349fe5$var$truncateSkillDescription = (description)=>{
    if (!description) return '';
    if (description.length <= $88d8e842aa349fe5$var$SKILL_DESCRIPTION_CHAR_LIMIT) return description;
    const slice = description.slice(0, $88d8e842aa349fe5$var$SKILL_DESCRIPTION_CHAR_LIMIT);
    const lastWhitespace = slice.search(/\s\S*$/);
    const truncated = lastWhitespace > 0 ? slice.slice(0, lastWhitespace) : slice;
    return `${truncated.trimEnd()}\u{2026}`;
};
const $88d8e842aa349fe5$var$skillsEditorMessages = (0, $aXWIB.defineMessages)({
    betaLabel: {
        id: "conversation-assistant-chat-prompt-input.skills-editor-extension.beta-label",
        defaultMessage: "Beta"
    }
});
const $88d8e842aa349fe5$var$adminSkillBetaLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
    appearance: "discovery",
    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...$88d8e842aa349fe5$var$skillsEditorMessages.betaLabel
    })
});
const $88d8e842aa349fe5$export$a728a4b0cfbf102d = ({ skills: skills, isConversationAgentic: isConversationAgentic, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true, siteId: siteId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)(); // Skill selection source is recorded on the AnalyticsPropertiesContext so the chat
    // input can attach it to the next `aiResult viewed` event without needing a
    // per-input store. The provider is mounted once per chat instance, scoping the value
    // to the input that consumes it.
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    const createManifest = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((skills)=>{
        const manifest = {
            title: 'Skills',
            type: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
            key: (0, $ij2FZ.ROVO_SKILL_EXTENSION_KEY),
            categories: [
                'Skills'
            ],
            icons: {
                '16': (0, $d3VBU.defaultIcon),
                '24': (0, $d3VBU.defaultIcon),
                '48': (0, $d3VBU.defaultIcon)
            },
            modules: {
                quickInsert: skills.map((skill)=>{
                    const { slug: slug, description: description, name: name, product: product, iconName: iconName, tags: tags } = skill;
                    const lozenge = tags?.some((t)=>t.toLowerCase() === 'beta') && (0, $dh538.fg)('rovo_chat_editor_admin_skill_beta_lozenge_enabled') ? $88d8e842aa349fe5$var$adminSkillBetaLozenge : undefined;
                    return {
                        key: slug,
                        keywords: [
                            'skills',
                            'skill',
                            slug,
                            product ?? ''
                        ],
                        // 1 is the default priority
                        priority: 99,
                        title: name,
                        description: $88d8e842aa349fe5$var$truncateSkillDescription(description),
                        icon: $88d8e842aa349fe5$var$getSkillIcon(iconName),
                        lozenge: lozenge,
                        action: async ()=>{
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'rovoChatSkillSelected',
                                attributes: {
                                    slashCommand: slug,
                                    skillProductKey: product,
                                    skillSelectionSource: 'editorTypeahead'
                                }
                            });
                            setAnalyticsPropertiesWithoutRerender({
                                skillSelectionSource: 'editorTypeahead'
                            });
                            return (0, $ij2FZ.createSkillNode)(skill);
                        }
                    };
                }),
                nodes: {
                    skillTag: {
                        type: 'inlineExtension',
                        render: async ()=>({ node: node })=>{
                                const params = node.parameters;
                                if (!params) return null;
                                 // Use ConnectedSkillTag to fetch and render full metadata so the pill matches the typeahead style.
                                if (siteId && !params.color && !params.iconName && (0, $c6GJD.default).getExperimentValue('enable_rovo_static_prompt_file_uploads', 'isEnabled', false)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eDYF8.ConnectedSkillTag), {
                                    slug: params.slug,
                                    siteId: siteId
                                });
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3QWW6.SkillTag), {
                                    ...params
                                });
                            }
                    }
                }
            }
        };
        return manifest;
    }, [
        sendAnalyticsEvent,
        setAnalyticsPropertiesWithoutRerender,
        siteId
    ]);
    const manifestProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        // Return undefined if skills are disabled
        if (!enableSkills) return undefined;
         // skills are only applicable to non-agentic conversations
        // remove skills if a skill is already present in the prompt until chaining is allowed
        if ((isConversationAgentic || promptHasSkill) && (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) return [
            new (0, $bre0g.default)([
                createManifest([])
            ])
        ];
        else if ((0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) return [
            new (0, $bre0g.default)([
                createManifest(skills)
            ])
        ];
        return undefined;
    }, [
        isConversationAgentic,
        promptHasSkill,
        createManifest,
        enableSkills,
        skills
    ]);
    return manifestProvider;
};


// Check if we're at 90% of the API limit (100 items)
const $276873685241a605$var$API_LIMIT = 100;
const $276873685241a605$var$PAGINATION_THRESHOLD = $276873685241a605$var$API_LIMIT * 0.9; // 90 items
const $276873685241a605$export$d985a50bcdf94a02 = ({ isConversationAgentic: isConversationAgentic, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true, siteId: siteId, editorApi: editorApi, ...props })=>{
    const legacySkillsResponse = (0, $irOoi.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseSkillEdges */ (0, $7dd36d4de66cae3d$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: $276873685241a605$var$API_LIMIT,
        relevantFor: [
            'SKILL'
        ],
        cloudId: siteId,
        surface: 'ROVO',
        shouldFetch: enableSkills && !(0, $dh538.fg)('rovo_chat_unified_skills_agg')
    })?.graphIntegration_componentDirectoryItems;
    const unifiedSkillsResponse = (0, $irOoi.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseUniversalSkillEdges and kept for future use */ (0, $ce9f50a5719db74f$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: $276873685241a605$var$API_LIMIT,
        cloudId: siteId,
        shouldFetch: enableSkills && (0, $dh538.fg)('rovo_chat_unified_skills_agg')
    })?.convoai_availableSkills;
    const skillsResponse = (0, $dh538.fg)('rovo_chat_unified_skills_agg') ? unifiedSkillsResponse : legacySkillsResponse;
    const skillsPaginationRef = (0, $42omo.useRef)(false);
    // Handle errors from both legacy and unified responses
    if (skillsResponse) {
        // Legacy error format
        if ('error' in skillsResponse && skillsResponse.error) {
            const err = skillsResponse.error;
            const errExtensions = err.extensions ? `[${err.extensions?.map((ext)=>`${ext?.statusCode} - ${ext?.errorType}`)?.join(', ')}] ` : '';
            throw new Error(err.message || errExtensions ? `${errExtensions}${err.message}` : 'Failed to load skills');
        }
        // Unified skills error format
        if ('errors' in skillsResponse && skillsResponse.errors && skillsResponse.errors.length > 0) {
            const errorMessages = skillsResponse.errors.map((err)=>err.message).join(', ');
            throw new Error(errorMessages || 'Failed to load skills');
        }
    }
    const skillCount = skillsResponse?.edges?.length ?? 0;
    if (skillCount >= $276873685241a605$var$PAGINATION_THRESHOLD && !skillsPaginationRef.current) {
        (0, $1yaYZ.logException)({
            exception: new Error(`Skills API limit threshold reached: ${skillCount} of ${$276873685241a605$var$API_LIMIT} items returned. Pagination is needed.`),
            name: 'aiMateBrowseSkillsPaginationLimit',
            tags: {
                skillCount: skillCount.toString(),
                apiLimit: $276873685241a605$var$API_LIMIT.toString()
            }
        });
        // prevent more than one log per render when threshold is reached
        skillsPaginationRef.current = true;
    }
    const skillsListAferLoad = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $lGVHb.parseUniversalSkillEdges)(skillsResponse?.edges ?? null), [
        skillsResponse?.edges
    ]);
    const editorExtensionManifest = (0, $88d8e842aa349fe5$export$a728a4b0cfbf102d)({
        skills: skillsListAferLoad,
        isConversationAgentic: isConversationAgentic,
        promptHasSkill: promptHasSkill,
        enableSkills: enableSkills,
        siteId: siteId
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const typeAheadWasOpenRef = (0, $42omo.useRef)(false);
    const onTypeAheadPluginState = (0, $42omo.useCallback)(({ typeAheadState: typeAheadState })=>{
        const isOpen = Boolean(typeAheadState?.isOpen);
        if (isOpen && !typeAheadWasOpenRef.current) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatEditorTypeAhead'
        });
        typeAheadWasOpenRef.current = isOpen;
    }, [
        sendAnalyticsEvent
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'typeAhead'
    ], onTypeAheadPluginState, {
        disabled: !editorApi
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
        extensionProviders: editorExtensionManifest,
        ...props
    });
};
module.exports["ComposableEditorWithSkills"] = $276873685241a605$export$d985a50bcdf94a02;

});

parcelRegister("d3VBU", function(module, exports) {

var $42omo = parcelRequire("42omo");





































const $fd687e8904fce28a$export$dce8bc0f04f0d915 = {
    skill: ()=>Promise.resolve((parcelRequire("bKhxF"))),
    assets: ()=>(parcelRequire("8OGHW")),
    add: ()=>Promise.resolve((parcelRequire("g5gZt"))),
    'chart-bar-line': ()=>(parcelRequire("4qVJ2")),
    'ai-generative-text': ()=>(parcelRequire("eqsS5")),
    'work-item': ()=>Promise.resolve((parcelRequire("2qVkt"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("9Q2dU"))),
    'chart-pie': ()=>(parcelRequire("8sr2T")),
    plan: ()=>(parcelRequire("i4zNS")),
    settings: ()=>Promise.resolve((parcelRequire("fIcbd"))),
    'project-status': ()=>(parcelRequire("6E8pW")),
    'merge-success': ()=>(parcelRequire("3mxkw")),
    'person-add': ()=>(parcelRequire("kMEmh")),
    'people-group': ()=>Promise.resolve((parcelRequire("lebfc"))),
    'person-added': ()=>(parcelRequire("pt6v8")),
    login: ()=>(parcelRequire("kURs4")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("a6IPc"))),
    transition: ()=>(parcelRequire("aho4H")),
    board: ()=>Promise.resolve((parcelRequire("5aaqS"))),
    release: ()=>Promise.resolve((parcelRequire("5j8et"))),
    'app-switcher': ()=>(parcelRequire("798YW")),
    search: ()=>Promise.resolve((parcelRequire("jluld"))),
    'playlist-add': ()=>(parcelRequire("dnSjb")),
    'playlist-remove': ()=>(parcelRequire("4kdB8")),
    summary: ()=>Promise.resolve((parcelRequire("a6IPc"))),
    clock: ()=>Promise.resolve((parcelRequire("kevJM"))),
    'ai-generative-chapters': ()=>(parcelRequire("kJyT8")),
    talent: ()=>(parcelRequire("i3Sza")),
    incident: ()=>Promise.resolve((parcelRequire("5LN4K"))),
    form: ()=>(parcelRequire("2CaDj")),
    ticket: ()=>(parcelRequire("kC0Cc")),
    alert: ()=>(parcelRequire("e6w7G")),
    pulse: ()=>(parcelRequire("186Qe")),
    'text-lengthen': ()=>(parcelRequire("7xeCY")),
    'ai-generative-cleanup': ()=>(parcelRequire("lwzVs")),
    survey: ()=>(parcelRequire("c58rI"))
};
const $fd687e8904fce28a$export$ca2f546e21dcce87 = $fd687e8904fce28a$export$dce8bc0f04f0d915.skill;
const $fd687e8904fce28a$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($fd687e8904fce28a$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $42omo.lazy)(loader)
    ]));
const $fd687e8904fce28a$export$78596fa6083c04d1 = $fd687e8904fce28a$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $fd687e8904fce28a$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $fd687e8904fce28a$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $fd687e8904fce28a$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $fd687e8904fce28a$export$78596fa6083c04d1;

});

parcelRegister("8OGHW", function(module, exports) {

let $66b41f16e830c814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b41f16e830c814$var$load("1yrlK").then(()=>parcelRequire('2LFoe'));

});

parcelRegister("4qVJ2", function(module, exports) {

let $33a65e3728a6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33a65e3728a6deed$var$load("czqcb").then(()=>parcelRequire('OmUay'));

});

parcelRegister("eqsS5", function(module, exports) {

let $a809e3a38eaabc9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a809e3a38eaabc9b$var$load("iAqyW").then(()=>parcelRequire('h7YX1'));

});

parcelRegister("8sr2T", function(module, exports) {

let $6285eaf809731400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6285eaf809731400$var$load("8vVzT").then(()=>parcelRequire('4DzVW'));

});

parcelRegister("i4zNS", function(module, exports) {

let $d2845f86362f2ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2845f86362f2ced$var$load("hpUn4").then(()=>parcelRequire('3Pjsu'));

});

parcelRegister("6E8pW", function(module, exports) {

let $4d6d0204a36cd6bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d6d0204a36cd6bd$var$load("l4YAS").then(()=>parcelRequire('f2ref'));

});

parcelRegister("3mxkw", function(module, exports) {

let $272d47d3be217e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $272d47d3be217e93$var$load("6HxBR").then(()=>parcelRequire('2KFft'));

});

parcelRegister("kMEmh", function(module, exports) {

let $f21798a7023c2d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f21798a7023c2d22$var$load("fjOTL").then(()=>parcelRequire('cDMVr'));

});

parcelRegister("pt6v8", function(module, exports) {

let $04c8e955877b500e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04c8e955877b500e$var$load("4rKYa").then(()=>parcelRequire('l8mxb'));

});

parcelRegister("kURs4", function(module, exports) {

let $f3a28009260eef94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3a28009260eef94$var$load("iMSgb").then(()=>parcelRequire('ilSNM'));

});

parcelRegister("aho4H", function(module, exports) {

let $77be2ab0ef9d3474$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77be2ab0ef9d3474$var$load("8Qv5g").then(()=>parcelRequire('cnlZf'));

});

parcelRegister("798YW", function(module, exports) {

let $5340574c778c8cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5340574c778c8cd4$var$load("48rvp").then(()=>parcelRequire('kNHXO'));

});

parcelRegister("dnSjb", function(module, exports) {

let $9be78cd6942a698e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9be78cd6942a698e$var$load("7kkP6").then(()=>parcelRequire('3DMri'));

});

parcelRegister("4kdB8", function(module, exports) {

let $326393f9ce2ef51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326393f9ce2ef51d$var$load("k2R9e").then(()=>parcelRequire('2Ihtu'));

});

parcelRegister("kJyT8", function(module, exports) {

let $f18312b6ea88af73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f18312b6ea88af73$var$load("1okAQ").then(()=>parcelRequire('iulqN'));

});

parcelRegister("i3Sza", function(module, exports) {

let $d262d588718b83e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d262d588718b83e3$var$load("eF7Ol").then(()=>parcelRequire('f7Fwi'));

});

parcelRegister("2CaDj", function(module, exports) {

let $1e7760e1b1d31574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e7760e1b1d31574$var$load("3TFqP").then(()=>parcelRequire('4JtPF'));

});

parcelRegister("kC0Cc", function(module, exports) {

let $f017d56eb0f65c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f017d56eb0f65c8a$var$load("334w0").then(()=>parcelRequire('kVwu3'));

});

parcelRegister("e6w7G", function(module, exports) {

let $a44a8b2afa568976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44a8b2afa568976$var$load("2ABJz").then(()=>parcelRequire('7Shff'));

});

parcelRegister("186Qe", function(module, exports) {

let $0d2bd8617a14a4d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2bd8617a14a4d3$var$load("cSj9q").then(()=>parcelRequire('8uomH'));

});

parcelRegister("7xeCY", function(module, exports) {

let $57c6f6319bc0dd8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57c6f6319bc0dd8e$var$load("9f5Sw").then(()=>parcelRequire('eugUs'));

});

parcelRegister("lwzVs", function(module, exports) {

let $fab87441f79abcca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab87441f79abcca$var$load("dYRAy").then(()=>parcelRequire('cbtR4'));

});

parcelRegister("c58rI", function(module, exports) {

let $8cbc80e42da4fe4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cbc80e42da4fe4b$var$load("2jXG3").then(()=>parcelRequire('gjyaY'));

});

parcelRegister("3QWW6", function(module, exports) {
/* SkillTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $i4C2H = parcelRequire("i4C2H");


var $4enat = parcelRequire("4enat");


var $I637S = parcelRequire("I637S");


var $72bJY = parcelRequire("72bJY");


var $kS0Is = parcelRequire("kS0Is");


var $d3VBU = parcelRequire("d3VBU");

const $4e067729dc89bc6a$var$styles = {
    parallelogram: "_2rkolb4i _18u01b66 _19bv12x7 _u5f312x7 _t9ec1hsb _1e0c1o8l",
    background: "_bfhki8nm",
    backgroundInverse: "_bfhk1vck",
    content: "_t9ecstek"
};
const $4e067729dc89bc6a$var$SkillTagInternal = ({ triggerProps: triggerProps = {}, invertColors: invertColors, slug: slug, IconComponent: IconComponent, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, color: color, shimmer: shimmer })=>{
    const borderColor = (0, $72bJY.getBorderColor)(color, invertColors);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: (0, $1Whri.cx)($4e067729dc89bc6a$var$styles.parallelogram, invertColors ? $4e067729dc89bc6a$var$styles.backgroundInverse : $4e067729dc89bc6a$var$styles.background),
        style: {
            borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${borderColor}`
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...triggerProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            xcss: $4e067729dc89bc6a$var$styles.content,
            space: "space.050",
            alignBlock: "center",
            children: [
                IconComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                    fallback: null,
                    interactionName: "skill-tag-icon",
                    children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                        label: "",
                        size: "small",
                        color: (0, $72bJY.getIconColor)(color, invertColors)
                    })
                }),
                shimmer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4enat.ShimmerText), {
                    children: slug
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: invertColors ? 'color.text.inverse' : 'color.text',
                    children: slug
                })
            ]
        })
    });
};
// delay opening and closing of the hovercard to prevent flickering
const $4e067729dc89bc6a$var$SKILL_TAG_HOVERCARD_DELAY = 200;
const $4e067729dc89bc6a$export$55feb0e4f341a6f6 = ({ invertColors: invertColors = false, disableHovercard: disableHovercard = false, product: product, iconName: iconName, ...props })=>{
    const IconComponent = iconName ? (0, $d3VBU.skillIconMap)[iconName] : undefined;
    const hasHovercardInfo = props?.name && props?.description;
    return disableHovercard || !hasHovercardInfo ? /*#__PURE__*/ (0, $l998X.jsx)($4e067729dc89bc6a$var$SkillTagInternal, {
        ...props,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        IconComponent: IconComponent
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $I637S.HoverCard), {
        placement: "top",
        fallbackPlacements: [
            'bottom',
            'left'
        ],
        autoFocus: false,
        hoverCardDelay: $4e067729dc89bc6a$var$SKILL_TAG_HOVERCARD_DELAY,
        shouldRenderToParent: false,
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $kS0Is.SkillHoverCardContent), {
            product: product,
            iconName: iconName,
            ...props
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($4e067729dc89bc6a$var$SkillTagInternal, {
            invertColors: invertColors,
            disableHovercard: disableHovercard,
            IconComponent: IconComponent,
            ...props
        })
    });
};
module.exports["SkillTag"] = $4e067729dc89bc6a$export$55feb0e4f341a6f6;

});

parcelRegister("I637S", function(module, exports) {
/* HoverCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lvsjl = parcelRequire("lvsjl");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

const $5d0bc1c04b0b0ff2$var$hovercardStyles = {
    trigger: "_1bsb1osq"
};
const $5d0bc1c04b0b0ff2$export$57a077cc9fbe653e = ({ content: content, children: children, placement: placement = 'left', autoFocus: autoFocus = false, fallbackPlacements: fallbackPlacements = [
    'bottom',
    'left',
    'right'
], disabled: disabled = false, hoverCardDelay: hoverCardDelay = 200, testId: testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent = true })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [setIsOpenDebounced, cancelSetIsOpen] = (0, $lvsjl.default)((open)=>{
        setIsOpen(open);
    }, hoverCardDelay);
    const contentId = (0, $42omo.useId)();
    if (disabled) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        autoFocus: autoFocus,
        isOpen: isOpen,
        shouldRenderToParent: shouldRenderToParent,
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: contentId,
                as: "span",
                onMouseEnter: ()=>cancelSetIsOpen(),
                onMouseLeave: ()=>setIsOpenDebounced(false),
                testId: testId ? `${testId}--content` : undefined,
                children: content
            }),
        trigger: (triggerProps)=>{
            // Filter out aria-expanded - it's invalid on non-interactive elements like <span>
            // aria-expanded is only valid on interactive elements (e.g., button, menuitem)
            // Use aria-describedby instead to link the trigger to the content for screen readers
            const { 'aria-expanded': _ariaExpanded, ...restTriggerProps } = triggerProps;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                ...restTriggerProps,
                "aria-describedby": contentId,
                testId: testId ? `${testId}--trigger` : undefined,
                xcss: $5d0bc1c04b0b0ff2$var$hovercardStyles.trigger,
                onMouseEnter: ()=>{
                    setIsOpenDebounced(true);
                    onMouseEnter?.();
                },
                onMouseLeave: ()=>{
                    setIsOpenDebounced(false);
                    onMouseLeave?.();
                },
                children: children
            });
        }
    });
};
module.exports["HoverCard"] = $5d0bc1c04b0b0ff2$export$57a077cc9fbe653e;

});

parcelRegister("72bJY", function(module, exports) {
const $ec34fab88b0489ec$export$3056677f7f7d8f5d = {
    LIME: {
        default: "var(--ds-border-accent-lime, #6A9A23)",
        icon: "var(--ds-icon-accent-lime, #6A9A23)"
    },
    RED: {
        default: "var(--ds-border-accent-red, #E2483D)",
        icon: "var(--ds-icon-accent-red, #C9372C)"
    },
    ORANGE: {
        default: "var(--ds-border-accent-orange, #E06C00)",
        icon: "var(--ds-icon-accent-orange, #E06C00)"
    },
    YELLOW: {
        default: "var(--ds-border-accent-yellow, #B38600)",
        icon: "var(--ds-icon-accent-yellow, #B38600)"
    },
    GREEN: {
        default: "var(--ds-border-accent-green, #22A06B)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    },
    TEAL: {
        default: "var(--ds-border-accent-teal, #2898BD)",
        icon: "var(--ds-icon-accent-teal, #2898BD)"
    },
    BLUE: {
        default: "var(--ds-border-accent-blue, #357DE8)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    PURPLE: {
        default: "var(--ds-border-accent-purple, #AF59E1)",
        icon: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    MAGENTA: {
        default: "var(--ds-border-accent-magenta, #CD519D)",
        icon: "var(--ds-icon-accent-magenta, #CD519D)"
    },
    GRAY: {
        default: "var(--ds-border-accent-gray, #7D818A)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    DEFAULT: {
        default: "var(--ds-border, #0B120E24)",
        inverse: "var(--ds-border-inverse, #FFFFFF)",
        icon: "var(--ds-icon-subtle, #505258)"
    }
};
const $ec34fab88b0489ec$export$dbc6cfecd630bcea = (color, invertColors)=>{
    if (color) {
        const colorObject = $ec34fab88b0489ec$export$3056677f7f7d8f5d[color];
        const colorType = invertColors ? 'inverse' : 'default';
        return colorObject?.[colorType] ?? colorObject?.default ?? "var(--ds-border, #0B120E24)";
    }
    return invertColors ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border, #0B120E24)";
};
const $ec34fab88b0489ec$export$bb417e0702eb86b5 = (color, invertColors)=>{
    if (color) {
        const colorObject = $ec34fab88b0489ec$export$3056677f7f7d8f5d[color];
        if (invertColors && color === 'DEFAULT') return "var(--ds-icon-inverse, #FFFFFF)";
        return colorObject?.icon ?? "var(--ds-icon-subtle, #505258)";
    }
    return invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
};
module.exports["getBorderColor"] = $ec34fab88b0489ec$export$dbc6cfecd630bcea;
module.exports["getIconColor"] = $ec34fab88b0489ec$export$bb417e0702eb86b5;

});

parcelRegister("kS0Is", function(module, exports) {
/* SkillHoverCardContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $i4C2H = parcelRequire("i4C2H");


var $72bJY = parcelRequire("72bJY");


var $d3VBU = parcelRequire("d3VBU");

const $953d0c1bf8c4322e$var$hovercardStyles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw _y3gn1e5h",
    skillName: "_k48pwu06 _otyru2gc _4cvr1h6o",
    product: "_19pkutpp _syazazsu _4cvr1h6o _1p1d1dk0"
};
const $953d0c1bf8c4322e$export$8582aebd1d6355d8 = ({ product: product, iconName: iconName, ...props })=>{
    const IconComponent = iconName ? (0, $d3VBU.skillIconMap)[iconName] : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $953d0c1bf8c4322e$var$hovercardStyles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    xcss: $953d0c1bf8c4322e$var$hovercardStyles.skillName,
                    space: "space.100",
                    children: [
                        IconComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                            fallback: null,
                            interactionName: "skill-tag-hovercard-icon",
                            children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                label: "",
                                size: "medium",
                                color: (0, $72bJY.getIconColor)(props?.color, props?.invertColors)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: props.name
                        })
                    ]
                }),
                props.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text",
                        children: props.description
                    })
                }),
                product && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    xcss: $953d0c1bf8c4322e$var$hovercardStyles.product,
                    space: "space.075",
                    children: [
                        props.productIconUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: props.productIconUrl,
                            testId: `${product}-icon`,
                            alt: "",
                            width: 16,
                            height: 16
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtle",
                            size: "small",
                            children: product
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["SkillHoverCardContent"] = $953d0c1bf8c4322e$export$8582aebd1d6355d8;

});

parcelRegister("eDYF8", function(module, exports) {
/* ConnectedSkillTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $i4C2H = parcelRequire("i4C2H");


var $16lEl = parcelRequire("16lEl");


var $1yaYZ = parcelRequire("1yaYZ");


var $gWF6I = parcelRequire("gWF6I");


var $3QWW6 = parcelRequire("3QWW6");


var $kfhjt = parcelRequire("kfhjt");

/**
 * Internal component that uses skill metadata from SkillMetadataProvider context.
 * This component must be used within a SkillMetadataProvider to function properly.
 *
 * @internal Use ConnectedSkillTag instead
 */ const $3820070b3d4a9f4a$var$ConnectedSkillTagInternal = ({ slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer, fallbackTag: fallbackTag })=>{
    const skillMetadata = (0, $kfhjt.useSkillMetadata)();
    if (!slug) return null;
     // Get the skill metadata for this slug
    const metadata = skillMetadata?.skillMetadataMap?.[slug]; // If we don't have metadata, render a basic tag with just the slug
    if (!metadata) return fallbackTag;
     // Render the SkillTag with full metadata
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3QWW6.SkillTag), {
        slug: slug,
        name: metadata.name,
        description: metadata.description,
        iconName: metadata.iconName,
        product: metadata.product,
        productIconUrl: metadata.productIconUrl,
        color: metadata.color,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        shimmer: shimmer
    });
};
const $3820070b3d4a9f4a$export$cd7b6803f49d5e03 = ({ siteId: siteId, slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer })=>{
    const fallbackTag = /*#__PURE__*/ (0, $l998X.jsx)((0, $3QWW6.SkillTag), {
        slug: slug,
        name: "",
        invertColors: invertColors,
        shimmer: shimmer,
        disableHovercard: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallbackRender: ()=>fallbackTag,
        onError: (error)=>{
            (0, $1yaYZ.logException)({
                exception: error,
                name: (0, $16lEl.ExperienceName).HYDRATE_SKILL_METADATA,
                tags: {
                    siteId: siteId
                }
            });
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.AtlassianRelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                interactionName: "rovo-connected-skill-tag",
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kfhjt.SkillMetadataProvider), {
                    siteId: siteId,
                    fetchWithoutTags: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($3820070b3d4a9f4a$var$ConnectedSkillTagInternal, {
                        slug: slug,
                        invertColors: invertColors,
                        disableHovercard: disableHovercard,
                        shimmer: shimmer,
                        fallbackTag: fallbackTag
                    })
                })
            })
        })
    });
};
module.exports["ConnectedSkillTag"] = $3820070b3d4a9f4a$export$cd7b6803f49d5e03;

});

parcelRegister("ZsUvD", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $5SEdb = parcelRequire("5SEdb");


var $bJOL1 = parcelRequire("bJOL1");


var $TZbdu = parcelRequire("TZbdu");

const $169827c496727c29$var$styles = {
    listWrapper: "_zulputpp _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1reo1wug _o5721q9c _p12f1osq _1dm8q5uf _1q51utpp _85i5utpp _bozgutpp _y4tiutpp",
    listItem: "_1pfhidpf"
};
const $169827c496727c29$var$useAutoScrollOnDataChange = (data)=>{
    const prevDataLength = (0, $42omo.useRef)(data.length);
    const [isAutoScroll, setIsAutoScroll] = (0, $42omo.useState)(false);
    const dataLength = data.length;
    (0, $42omo.useEffect)(()=>{
        if (prevDataLength.current < dataLength) setIsAutoScroll(true);
        else setIsAutoScroll(false);
        prevDataLength.current = dataLength;
    }, [
        dataLength
    ]);
    return isAutoScroll;
};
const $169827c496727c29$export$20d4570a6e3e703b = ({ attachtmentsStoreKey: attachtmentsStoreKey })=>{
    const [attachmentsState, { removeExternalContext: removeExternalContext, removeFile: removeFile }] = (0, $bJOL1.useAllAttachmentsStore)(attachtmentsStoreKey);
    const isAutoScroll = $169827c496727c29$var$useAutoScrollOnDataChange(attachmentsState);
    if (attachmentsState.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "ul",
        xcss: $169827c496727c29$var$styles.listWrapper,
        children: attachmentsState.map((context, index)=>{
            const isLast = index === attachmentsState.length - 1;
            let key;
            let content;
            switch(context.type){
                case 'file':
                    const file = context.data;
                    key = file.name;
                    content = /*#__PURE__*/ (0, $l998X.jsx)((0, $TZbdu.FileCard), {
                        fileName: file.name,
                        onRemove: ()=>removeFile(attachtmentsStoreKey, file.name),
                        isLoading: file.isLoading,
                        error: file.error,
                        autoScroll: isAutoScroll && Boolean(file.error || isLast),
                        previewBlobUrl: file.previewBlobUrl,
                        isPreviewLoading: file.isPreviewLoading,
                        fileObject: file.fileObject
                    });
                    break;
                case 'external':
                    const promptInputContext = context.data;
                    const externalContext = promptInputContext.representation;
                    key = promptInputContext.key;
                    content = /*#__PURE__*/ (0, $l998X.jsx)((0, $5SEdb.PreviewCard), {
                        label: externalContext.label,
                        subLabel: externalContext.description,
                        onRemove: ()=>removeExternalContext(attachtmentsStoreKey, promptInputContext.key),
                        autoScroll: isAutoScroll && Boolean(isLast),
                        cardIcon: externalContext.image
                    });
                    break;
                default:
                    return null;
            }
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "li",
                xcss: $169827c496727c29$var$styles.listItem,
                children: content
            }, key);
        })
    });
};
module.exports["InputContextListDisplay"] = $169827c496727c29$export$20d4570a6e3e703b;

});

parcelRegister("TZbdu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $kIvLT = parcelRequire("kIvLT");


var $1yaYZ = parcelRequire("1yaYZ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Note: React imported explicitly to avoid CommonJS build issues with Compiled library; see https://atlassian.slack.com/archives/C08BQ9QDRFX/p1748283909199679
// @ts-expect-error - React explicitly imported to avoid CommonJS build issues with Compiled library; TS6133 false positive
// eslint-disable-next-line no-unused-vars







const $77341e7889b8b78c$var$ArchiveIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8Q8zP")));

const $77341e7889b8b78c$var$AudioIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcJ56")));

const $77341e7889b8b78c$var$DocumentIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hPbZ1")));

const $77341e7889b8b78c$var$ExcelIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7X7LY")));

const $77341e7889b8b78c$var$GenericIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("e0WgM")));

const $77341e7889b8b78c$var$GoogleDocIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fk3Vu")));

const $77341e7889b8b78c$var$GoogleSheetIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lGa5e")));

const $77341e7889b8b78c$var$GoogleSlideIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1DZBp")));

const $77341e7889b8b78c$var$ImageIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("478Ii")));

const $77341e7889b8b78c$var$PDFIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9ZH0J")));

const $77341e7889b8b78c$var$PowerpointIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gkryH")));

const $77341e7889b8b78c$var$SourceCodeIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iM8DS")));

const $77341e7889b8b78c$var$SpreadsheetIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4wiOi")));

const $77341e7889b8b78c$var$VideoIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6Cxjr")));

const $77341e7889b8b78c$var$WordDocumentIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kjtlE"))); // Icons

const $77341e7889b8b78c$var$ArchiveIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5dAfr")));

const $77341e7889b8b78c$var$AudioIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("33MJ0")));

const $77341e7889b8b78c$var$DocumentIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a391j")));

const $77341e7889b8b78c$var$ExcelIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("516g5")));

const $77341e7889b8b78c$var$GenericIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5xGTZ")));

const $77341e7889b8b78c$var$GoogleDocIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c8ZoX")));

const $77341e7889b8b78c$var$GoogleSheetIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9wre1")));

const $77341e7889b8b78c$var$GoogleSlideIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htcSJ")));

const $77341e7889b8b78c$var$ImageIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gSwgA")));

const $77341e7889b8b78c$var$PDFIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7peNt")));

const $77341e7889b8b78c$var$PowerpointIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ffDhW")));

const $77341e7889b8b78c$var$SourceCodeIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jQ6zD")));

const $77341e7889b8b78c$var$SpreadsheetIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9d0HU")));

const $77341e7889b8b78c$var$VideoIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8MDgw")));

const $77341e7889b8b78c$var$WordDocumentIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5lE6Q"))); // New icons

const $77341e7889b8b78c$var$ImageIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("fZtQj"))));

const $77341e7889b8b78c$var$FileNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("chO1Z"))));

const $77341e7889b8b78c$var$VideoIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2Yaht"))));

const $77341e7889b8b78c$var$AudioIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lOjGk")));

const $77341e7889b8b78c$var$SpreadsheetIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fr6FA")));
const $77341e7889b8b78c$export$a697c9ed370839d5 = ({ fileName: fileName, ...props })=>{
    const fileExtension = fileName.split('.').pop();
    if (!fileExtension) return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
        label: ""
    });
    switch(fileExtension.toLowerCase()){
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIconNew, {
                ...props,
                label: ""
            });
        // Spreadsheets
        case 'csv':
        case 'tsv':
        case 'xls':
        case 'xlsx':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIconNew, {
                ...props,
                label: ""
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIconNew, {
                ...props,
                label: ""
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIconNew, {
                ...props,
                label: ""
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$FileNew, {
                ...props,
                label: ""
            });
    }
};
const $77341e7889b8b78c$export$8c1a3d13e85d78b7 = ({ fileName: fileName, size: size = 'small' })=>{
    const fileExtension = fileName.split('.').pop();
    if (!fileExtension) return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
        label: ""
    }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIconMedium, {
        label: ""
    });
    switch(fileExtension.toLowerCase()){
        // TXT Files
        case 'txt':
        case 'md':
        case 'log':
        case 'json':
        case 'yaml':
        case 'yml':
        case 'xml':
        case 'rtf':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$DocumentIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$DocumentIconMedium, {
                label: ""
            });
        // Plain Spreadsheets
        case 'csv':
        case 'tsv':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIconMedium, {
                label: ""
            });
        // Word Documents
        case 'doc':
        case 'docx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$WordDocumentIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$WordDocumentIconMedium, {
                label: ""
            });
        // PDF Files
        case 'pdf':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PDFIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PDFIconMedium, {
                label: ""
            });
        // PowerPoint Presentations
        case 'ppt':
        case 'pptx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PowerpointIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PowerpointIconMedium, {
                label: ""
            });
        // Excel Spreadsheets
        case 'xls':
        case 'xlsx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ExcelIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ExcelIconMedium, {
                label: ""
            });
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIconMedium, {
                label: ""
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIconMedium, {
                label: ""
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIconMedium, {
                label: ""
            });
        case 'zip':
        case 'rar':
        case '7z':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ArchiveIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ArchiveIconMedium, {
                label: ""
            });
        // Source Code
        case 'css':
        case 'html':
        case 'htm':
        case 'c':
        case 'cpp':
        case 'cs':
        case 'java':
        case 'js':
        case 'jsx':
        case 'vue':
        case 'svelte':
        case 'as':
        case 'sh':
        case 'bash':
        case 'bats':
        case 'h':
        case 'cc':
        case 'cxx':
        case 'hpp':
        case 'hxx':
        case 'coffee':
        case 'litcoffee':
        case 'clj':
        case 'cljs':
        case 'cljc':
        case 'edn':
        case 'dockerfile':
        case 'dockerignore':
        case 'erl':
        case 'hrl':
        case 'f':
        case 'for':
        case 'f90':
        case 'f95':
        case 'f03':
        case 'f08':
        case 'go':
        case 'kt':
        case 'kts':
        case 'tex':
        case 'sty':
        case 'cls':
        case 'less':
        case 'makefile':
        case 'mak':
        case 'mk':
        case 'm':
        case 'mat':
        case 'mm':
        case 'pas':
        case 'pp':
        case 'p':
        case 'pl':
        case 'pm':
        case 't':
        case 'pod':
        case 'php':
        case 'php3':
        case 'php4':
        case 'php5':
        case 'phtml':
        case 'py':
        case 'pyw':
        case 'pyc':
        case 'pyo':
        case 'pyd':
        case 'r':
        case 'rb':
        case 'erb':
        case 'rake':
        case 'gemspec':
        case 'rs':
        case 'rslib':
        case 'sas':
        case 'sas7bdat':
        case 'scss':
        case 'sass':
        case 'scala':
        case 'sc':
        case 'sbt':
        case 'st':
        case 'sm':
        case 'sql':
        case 'swift':
        case 'tcl':
        case 'itcl':
        case 'ts':
        case 'tsx':
        case 'v':
        case 'vh':
        case 'vhd':
        case 'vhdl':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SourceCodeIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SourceCodeIconMedium, {
                label: ""
            });
        case 'gdoc':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleDocIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleDocIconMedium, {
                label: ""
            });
        case 'gsheet':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSheetIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSheetIconMedium, {
                label: ""
            });
        case 'gslide':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSlideIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSlideIconMedium, {
                label: ""
            });
        default:
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIconMedium, {
                label: ""
            });
    }
};



var $5SEdb = parcelRequire("5SEdb");


var $auPMn = parcelRequire("auPMn");


var $cgmTK = parcelRequire("cgmTK");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");




var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");










const $48abd69c594aae8c$var$message = (0, $aXWIB.defineMessages)({
    previewNotAvailable: {
        id: "ai-mate.file-preview-modal.preview-not-available",
        defaultMessage: "Preview not available for this file type"
    }
});
var $48abd69c594aae8c$export$2e2bcd8739ae039 = $48abd69c594aae8c$var$message;


const $47ed744b079f29c0$var$styles = {
    imagePreview: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1osq _c71l1us8 _5ral1f51 _1e0c1ule",
    pdfPreview: "_19itglyw _1bsb1osq _4t3i1us8 _1e0c1ule",
    loadingContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _1tke1kdj",
    textPreview: "_1reo1wug _18m91wug _2rko12b0 _11c819w5 _c71l1us8 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhki8nm _o5721jtm _1nmz1hna"
}; /**
    * Determines file type category from MIME type or file name
    */ 
const $47ed744b079f29c0$var$getFileType = (file)=>{
    if (file.type.startsWith('image/')) return 'image';
    if (file.type === 'application/pdf') return 'pdf';
    if ((0, $auPMn.isTextFile)(file.type, file.name)) return 'text';
    return 'unknown';
}; /**
    * Modal component for previewing images, PDFs, and text files.
    */ 
const $47ed744b079f29c0$export$7e11cd3da4852b36 = ({ isOpen: isOpen, onClose: onClose, fileName: fileName, fileObject: fileObject, previewBlobUrl: previewBlobUrl, textContent: textContent, isLoadingText: isLoadingText })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const fileType = fileObject ? $47ed744b079f29c0$var$getFileType(fileObject) : previewBlobUrl ? 'image' : 'unknown';
    const [pdfBlobUrl, setPdfBlobUrl] = (0, $42omo.useState)(null); // Create PDF blob URL and track errors
    (0, $42omo.useEffect)(()=>{
        if (fileType === 'pdf' && fileObject) try {
            const blobUrl = URL.createObjectURL(fileObject);
            setPdfBlobUrl(blobUrl);
        } catch (error) {
            // Log error to Sentry for monitoring
            (0, $1yaYZ.logException)({
                exception: error,
                name: 'pdf-blob-url-creation-error',
                tags: {
                    fileType: fileObject.type
                }
            }); // User will see "Preview not available" message
            setPdfBlobUrl(null);
        }
        else setPdfBlobUrl(null);
    }, [
        fileType,
        fileObject
    ]); // Cleanup PDF blob URL on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
        };
    }, [
        pdfBlobUrl
    ]);
    const renderPreview = ()=>{
        if (fileType === 'image' && previewBlobUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            src: previewBlobUrl,
            alt: fileName,
            xcss: $47ed744b079f29c0$var$styles.imagePreview
        });
        if (fileType === 'pdf' && pdfBlobUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "object",
            type: "application/pdf",
            data: `${pdfBlobUrl}#toolbar=1`,
            title: fileName,
            xcss: $47ed744b079f29c0$var$styles.pdfPreview,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "embed",
                type: "application/pdf",
                src: `${pdfBlobUrl}#toolbar=1`,
                xcss: $47ed744b079f29c0$var$styles.pdfPreview
            })
        });
        if (fileType === 'text') {
            if (isLoadingText) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $47ed744b079f29c0$var$styles.loadingContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "large"
                })
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $47ed744b079f29c0$var$styles.textPreview,
                children: textContent
            });
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $47ed744b079f29c0$var$styles.loadingContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $48abd69c594aae8c$export$2e2bcd8739ae039).previewNotAvailable)
            })
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: onClose,
            width: "x-large",
            shouldScrollInViewport: true,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: fileName
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    hasInlinePadding: false,
                    children: renderPreview()
                })
            ]
        })
    });
};





const $52d66d6d58d8ca49$var$message = (0, $aXWIB.defineMessages)({
    removeFileLabel: {
        id: "ai-mate.chat-input.remove-file-label",
        defaultMessage: "Remove file {fileName}"
    },
    fileErrorIconLabel: {
        id: "ai-mate.chat-input.file-error-icon-label",
        defaultMessage: "Error loading file"
    },
    textLoadFailed: {
        id: "ai-mate.chat-input.text-load-failed",
        defaultMessage: "Failed to load file content"
    },
    textFileTooLarge: {
        id: "ai-mate.chat-input.text-file-too-large",
        defaultMessage: "This file is too large to preview ({sizeMB}MB)."
    }
});
var $52d66d6d58d8ca49$export$2e2bcd8739ae039 = $52d66d6d58d8ca49$var$message;


const $526d9c7505b62ef8$var$MAX_TEXT_SIZE = 2097152;
const $526d9c7505b62ef8$var$styles = {
    fileCardBgWrapper: "_2rko12b0 _bfhkhp5a _1e0c1txw"
};
const $526d9c7505b62ef8$var$FileCardBgWrappper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $526d9c7505b62ef8$var$styles.fileCardBgWrapper,
        children: children
    });
};
const $526d9c7505b62ef8$var$getFileNameAndExtension = (fileName)=>{
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) return {
        name: fileName,
        extension: ''
    };
    return {
        name: fileName.slice(0, lastDotIndex),
        extension: fileName.slice(lastDotIndex + 1)
    };
};
const $526d9c7505b62ef8$export$593fd10f7e6c6505 = ({ fileName: fileName, onRemove: onRemove, isLoading: isLoading, error: error, autoScroll: autoScroll, previewBlobUrl: previewBlobUrl, isPreviewLoading: isPreviewLoading, fileObject: fileObject })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { name: fileNameWithoutExtension, extension: extension } = $526d9c7505b62ef8$var$getFileNameAndExtension(fileName);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [textContent, setTextContent] = (0, $42omo.useState)(null);
    const [isLoadingText, setIsLoadingText] = (0, $42omo.useState)(false);
    const handleCardClick = (0, $42omo.useCallback)(()=>{
        if (!fileObject) return;
        if ((0, $auPMn.isTextFile)(fileObject.type, fileObject.name)) {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsLoadingText(true);
            setIsModalOpen(true); // Performance safeguard: Limit text file preview to 2MB
            if (fileObject.size > $526d9c7505b62ef8$var$MAX_TEXT_SIZE) {
                const sizeMB = (fileObject.size / 1048576).toFixed(1);
                setTextContent(formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).textFileTooLarge, {
                    sizeMB: sizeMB
                }));
                setIsLoadingText(false);
                return;
            }
            fileObject.text().then((content)=>{
                setTextContent(content);
                setIsLoadingText(false);
            }).catch((error)=>{
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'text-file-content-load-error',
                    tags: {
                        fileType: fileObject.type
                    }
                });
                const errorMessage = error instanceof Error ? error.message : formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).textLoadFailed);
                setTextContent(errorMessage);
                setIsLoadingText(false);
            });
        } else if ((0, $cgmTK.looksLikeImage)(fileObject) || fileObject.type === 'application/pdf') {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsModalOpen(true);
        }
    }, [
        fileObject,
        formatMessage,
        sendAnalyticsEvent
    ]);
    const isPreviewableType = fileObject && ((0, $cgmTK.looksLikeImage)(fileObject) || fileObject.type === 'application/pdf' || (0, $auPMn.isTextFile)(fileObject.type, fileObject.name));
    const canOpenPreview = isPreviewableType && !isLoading && !isPreviewLoading && !error;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5SEdb.PreviewCard), {
                autoScroll: autoScroll,
                label: fileNameWithoutExtension,
                subLabel: extension?.toUpperCase(),
                isLoading: isLoading || isPreviewLoading,
                error: error,
                onRemove: onRemove,
                imageSrc: previewBlobUrl,
                onClick: canOpenPreview ? handleCardClick : undefined,
                cardIcon: /*#__PURE__*/ (0, $l998X.jsx)($526d9c7505b62ef8$var$FileCardBgWrappper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $77341e7889b8b78c$export$8c1a3d13e85d78b7), {
                        fileName: fileName,
                        size: "medium"
                    })
                }),
                subLabelIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, $77341e7889b8b78c$export$a697c9ed370839d5), {
                    size: "small",
                    fileName: fileName,
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                errorLabel: formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).fileErrorIconLabel),
                removeLabel: formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).removeFileLabel, {
                    fileName: fileName
                })
            }),
            canOpenPreview && /*#__PURE__*/ (0, $l998X.jsx)((0, $47ed744b079f29c0$export$7e11cd3da4852b36), {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false),
                fileName: fileName,
                fileObject: fileObject,
                previewBlobUrl: previewBlobUrl,
                textContent: textContent,
                isLoadingText: isLoadingText
            })
        ]
    });
};
module.exports["FileCard"] = $526d9c7505b62ef8$export$593fd10f7e6c6505;

});

parcelRegister("8Q8zP", function(module, exports) {

let $66f9d53b36a1c87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66f9d53b36a1c87f$var$load("2fk6g").then(()=>parcelRequire('fX9Sa'));

});

parcelRegister("hcJ56", function(module, exports) {

let $c86686e07b9e0d86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c86686e07b9e0d86$var$load("72780").then(()=>parcelRequire('gguok'));

});

parcelRegister("hPbZ1", function(module, exports) {

let $cfa07eba164e68ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfa07eba164e68ea$var$load("3M4Om").then(()=>parcelRequire('i9cac'));

});

parcelRegister("7X7LY", function(module, exports) {

let $5ca4129d5a883a9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ca4129d5a883a9f$var$load("eTBsW").then(()=>parcelRequire('gH8Rx'));

});

parcelRegister("e0WgM", function(module, exports) {

let $a33e43e36164aa57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a33e43e36164aa57$var$load("3QZdB").then(()=>parcelRequire('djgQ6'));

});

parcelRegister("fk3Vu", function(module, exports) {

let $b27bc4f01f81a82c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b27bc4f01f81a82c$var$load("lxiFd").then(()=>parcelRequire('5W6v1'));

});

parcelRegister("lGa5e", function(module, exports) {

let $fc8557957af59f74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc8557957af59f74$var$load("6HBYC").then(()=>parcelRequire('giYeH'));

});

parcelRegister("1DZBp", function(module, exports) {

let $132937e71aaf3ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $132937e71aaf3ed1$var$load("bYxCZ").then(()=>parcelRequire('eWLPt'));

});

parcelRegister("478Ii", function(module, exports) {

let $2fee932bd4798889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fee932bd4798889$var$load("hszIA").then(()=>parcelRequire('20uDq'));

});

parcelRegister("9ZH0J", function(module, exports) {

let $746b2ca068d8f3b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $746b2ca068d8f3b8$var$load("eVYW1").then(()=>parcelRequire('lzyQK'));

});

parcelRegister("gkryH", function(module, exports) {

let $be33e4276f6027a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be33e4276f6027a7$var$load("020xd").then(()=>parcelRequire('dfQbH'));

});

parcelRegister("iM8DS", function(module, exports) {

let $dab369d9cf26d73b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab369d9cf26d73b$var$load("6vhrJ").then(()=>parcelRequire('7t8Pn'));

});

parcelRegister("4wiOi", function(module, exports) {

let $34a8bde8f0badcda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34a8bde8f0badcda$var$load("fxC6e").then(()=>parcelRequire('iFCP2'));

});

parcelRegister("6Cxjr", function(module, exports) {

let $4d2021df6d8f57b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d2021df6d8f57b5$var$load("4jPsO").then(()=>parcelRequire('hXc8o'));

});

parcelRegister("kjtlE", function(module, exports) {

let $ec9c58f6e253e433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9c58f6e253e433$var$load("ls0Um").then(()=>parcelRequire('lkBga'));

});

parcelRegister("5dAfr", function(module, exports) {

let $3cca48c73573eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3cca48c73573eb39$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("33MJ0", function(module, exports) {

let $23a772a51c01d9a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23a772a51c01d9a7$var$load("jDjSj").then(()=>parcelRequire('d4cCP'));

});

parcelRegister("a391j", function(module, exports) {

let $75112e6908a8d876$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75112e6908a8d876$var$load("ajMch").then(()=>parcelRequire('5mB97'));

});

parcelRegister("516g5", function(module, exports) {

let $3a71e68ec6145457$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a71e68ec6145457$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("5xGTZ", function(module, exports) {

let $4091504af4e03eec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4091504af4e03eec$var$load("kknf5").then(()=>parcelRequire('8DZd1'));

});

parcelRegister("c8ZoX", function(module, exports) {

let $8d75dc799514e943$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d75dc799514e943$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("9wre1", function(module, exports) {

let $6eec388d67832b92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6eec388d67832b92$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("htcSJ", function(module, exports) {

let $cb7f232b5be92725$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7f232b5be92725$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("gSwgA", function(module, exports) {

let $c49ab7ec4a42565a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c49ab7ec4a42565a$var$load("8059b").then(()=>parcelRequire('41GKb'));

});

parcelRegister("7peNt", function(module, exports) {

let $5646588e31a854db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5646588e31a854db$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("ffDhW", function(module, exports) {

let $b1a6bb9a21a18a09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1a6bb9a21a18a09$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("jQ6zD", function(module, exports) {

let $e717f90bdc95406f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e717f90bdc95406f$var$load("3wmvj").then(()=>parcelRequire('1iV2p'));

});

parcelRegister("9d0HU", function(module, exports) {

let $6b45e0647d2694b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b45e0647d2694b9$var$load("6BeQr").then(()=>parcelRequire('lxsNd'));

});

parcelRegister("8MDgw", function(module, exports) {

let $01a678d5b4524a60$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01a678d5b4524a60$var$load("hPalR").then(()=>parcelRequire('ayTrS'));

});

parcelRegister("5lE6Q", function(module, exports) {

let $3e4e06d4705f4ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e4e06d4705f4ba7$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("lOjGk", function(module, exports) {

let $fe0d88dae1629de4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe0d88dae1629de4$var$load("jDjSj").then(()=>parcelRequire('e3TOY'));

});

parcelRegister("fr6FA", function(module, exports) {

let $b3ce8d1877f61f41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3ce8d1877f61f41$var$load("jbmut").then(()=>parcelRequire('1pBUz'));

});

parcelRegister("51MhX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ij2FZ = parcelRequire("ij2FZ");

const $018eb73347941f3f$export$d1baf60959ac76d8 = (doc)=>{
    let actualTextContent = '';
    doc.descendants((node)=>{
        if (node.isText) actualTextContent = actualTextContent + node.text;
        else if (node.type.name === 'mention') {
            let mentionText = node.attrs.text || "@\u2026";
            actualTextContent = actualTextContent + mentionText;
        } else if (node.type.name === 'inlineCard') {
            const url = node.attrs.url || '';
            actualTextContent = actualTextContent + url;
        } else if (node.type.name === 'inlineExtension' && node.attrs.extensionType === (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE) && (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) {
            const skillSlug = node.attrs.parameters?.slug || '';
            actualTextContent = actualTextContent + skillSlug;
        }
        // For other node types, continue traversing but don't count them
        return true;
    });
    return actualTextContent;
};
const $018eb73347941f3f$export$5008f08b2ad8f7df = (doc)=>{
    const actualTextContent = $018eb73347941f3f$export$d1baf60959ac76d8(doc);
    return actualTextContent.trim().length;
};
module.exports["getActualTextContent"] = $018eb73347941f3f$export$d1baf60959ac76d8;
module.exports["getActualTextContentLength"] = $018eb73347941f3f$export$5008f08b2ad8f7df;

});

parcelRegister("2Yc46", function(module, exports) {
/**
 * Auto-apply controllers and hooks
 */ 
var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $1yaYZ = parcelRequire("1yaYZ");


var $i1Nyn = parcelRequire("i1Nyn");





var $gHaxX = parcelRequire("gHaxX");


var $d4Pk4 = parcelRequire("d4Pk4");




/**
 * Constants for auto-apply functionality
 */ const $5bb909103ff2a6d1$export$3317b9c0d88ecd38 = 'ai-mate-auto-apply-enabled';
const $5bb909103ff2a6d1$export$e46d7815fa70b734 = 'enable_auto_apply_toggling';


/**
 * @generated SignedSource<<44740e0f599cf23fde7ac25cf45f343d>>
 * @relayHash de75149bd6de46cf773dd86b1156f83a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b
const $3ad35185df377655$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_updateCreationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b",
            "metadata": {},
            "name": "creationSettingsMutationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3ad35185df377655$var$node.hash = "2764b2132df7149a218d7fe86758b452";
var $3ad35185df377655$export$2e2bcd8739ae039 = $3ad35185df377655$var$node;


/**
 * @generated SignedSource<<db4dd10a4e100afc581c7518b1f1eaff>>
 * @relayHash 2da18ddcf067ae3b3f655513eb48acac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0
const $406a28720a18ef49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_creationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0",
            "metadata": {},
            "name": "creationSettingsQueryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$406a28720a18ef49$var$node.hash = "d5e237e68920e0355d028a1df4e44e10";
var $406a28720a18ef49$export$2e2bcd8739ae039 = $406a28720a18ef49$var$node;


/**
 * Convert cloudId to tenantId ARI format
 */ function $45c1578a6ac72ff4$var$tenantIdToAri(cloudId) {
    return (0, $d4Pk4.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
}
/**
 * Convert userId to ownerAri format
 */ function $45c1578a6ac72ff4$var$userIdToAri(userId) {
    return (0, $gHaxX.IdentityUserAri).create({
        userId: userId
    }).toString();
}
function $45c1578a6ac72ff4$export$cbd1b24c4f50480f() {
    try {
        const stored = window.localStorage.getItem((0, $5bb909103ff2a6d1$export$3317b9c0d88ecd38));
        return stored !== null ? JSON.parse(stored) : true;
    } catch  {
        return true; // fallback to default
    }
}
function $45c1578a6ac72ff4$export$dedcc43382a0a2d(enabled) {
    try {
        window.localStorage.setItem((0, $5bb909103ff2a6d1$export$3317b9c0d88ecd38), JSON.stringify(enabled));
        window.dispatchEvent(new CustomEvent('autoApplyChanged'));
    } catch  {
    // Silently fail if localStorage is unavailable
    }
}
function $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri) {
    const variables = {
        tenantId: tenantId,
        ownerAri: ownerAri
    };
    (0, $1yaYZ.addSentryBreadcrumb)(`getAutoApplyStateFromBackend: fetching for tenant=${tenantId}`);
    return (0, $irOoi.fetchQuery)(environment, (0, $406a28720a18ef49$export$2e2bcd8739ae039), variables).toPromise().then((response)=>{
        // Reject if no response
        if (!response) {
            (0, $1yaYZ.addSentryBreadcrumb)('getAutoApplyStateFromBackend: no response received');
            throw new Error('Failed to fetch creation settings: No response');
        }
        // Return the autoApply value from backend, default to true if not found
        const autoApply = response?.settings_creationSettings?.autoApply ?? true;
        (0, $1yaYZ.addSentryBreadcrumb)(`getAutoApplyStateFromBackend: received autoApply=${autoApply}`);
        return autoApply;
    });
}
function $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply) {
    const input = {
        tenantId: tenantId,
        ownerAri: ownerAri,
        autoApply: autoApply
    };
    (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateToBackend: setting autoApply=${autoApply} for tenant=${tenantId}`);
    return new Promise((resolve, reject)=>{
        (0, $irOoi.commitMutation)(environment, {
            mutation: (0, $3ad35185df377655$export$2e2bcd8739ae039),
            variables: {
                input: input
            },
            onCompleted: (response, errors)=>{
                const payload = response.settings_updateCreationSettings;
                if (errors || !payload) {
                    (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation failed with errors`);
                    reject(errors || 'Failed to update creation settings');
                } else {
                    (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation succeeded, autoApply=${autoApply}`);
                    // Also update localStorage as cache/fallback
                    $45c1578a6ac72ff4$export$dedcc43382a0a2d(autoApply);
                    resolve(autoApply);
                }
            },
            onError: (error)=>{
                (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation error - ${error?.message || 'unknown'}`);
                // Reject so caller can handle the failure
                reject(error);
            }
        });
    });
}
function $45c1578a6ac72ff4$export$ff4d41d780f8bf44() {
    const currentState = $45c1578a6ac72ff4$export$cbd1b24c4f50480f();
    const newState = !currentState;
    $45c1578a6ac72ff4$export$dedcc43382a0a2d(newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$5b78d0cd3e8869ab(environment, sessionData) {
    (0, $1yaYZ.addSentryBreadcrumb)('toggleAutoApplyStateWithSession: toggling state');
    const currentState = await $45c1578a6ac72ff4$export$de3027235ba834ab(environment, sessionData);
    const newState = !currentState;
    (0, $1yaYZ.addSentryBreadcrumb)(`toggleAutoApplyStateWithSession: ${currentState} -> ${newState}`);
    // Update both backend and localStorage
    await $45c1578a6ac72ff4$export$284464f4da8ebd9(environment, sessionData, newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$32ad7f49a3b9fcd9(environment, tenantId, ownerAri) {
    (0, $1yaYZ.addSentryBreadcrumb)('toggleAutoApplyStateToBackend: toggling state');
    const currentState = await $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
    const newState = !currentState;
    (0, $1yaYZ.addSentryBreadcrumb)(`toggleAutoApplyStateToBackend: ${currentState} -> ${newState}`);
    // Update both backend and localStorage
    await $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$de3027235ba834ab(environment, sessionData) {
    if (!sessionData.userId) {
        // Fallback to localStorage for anonymous users
        (0, $1yaYZ.addSentryBreadcrumb)('getAutoApplyStateWithSession: no userId, falling back to localStorage');
        return $45c1578a6ac72ff4$export$cbd1b24c4f50480f();
    }
    const tenantId = $45c1578a6ac72ff4$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $45c1578a6ac72ff4$var$userIdToAri(sessionData.userId);
    (0, $1yaYZ.addSentryBreadcrumb)(`getAutoApplyStateWithSession: fetching for cloudId=${sessionData.cloudId}`);
    return $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
}
async function $45c1578a6ac72ff4$export$284464f4da8ebd9(environment, sessionData, autoApply) {
    if (!sessionData.userId) {
        // Fallback to localStorage for anonymous users
        (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateWithSession: no userId, using localStorage, autoApply=${autoApply}`);
        $45c1578a6ac72ff4$export$dedcc43382a0a2d(autoApply);
        return autoApply;
    }
    const tenantId = $45c1578a6ac72ff4$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $45c1578a6ac72ff4$var$userIdToAri(sessionData.userId);
    (0, $1yaYZ.addSentryBreadcrumb)(`setAutoApplyStateWithSession: setting autoApply=${autoApply} for cloudId=${sessionData.cloudId}`);
    return $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply);
}
function $45c1578a6ac72ff4$export$308de05ffc91835d(environment, tenantId, ownerAri, setState) {
    return async ()=>{
        const enabled = await $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
        setState(enabled);
    };
}


// ============================================================================
// Helpers
// ============================================================================
/**
 * Safely gets the Relay environment without throwing if no provider is available.
 * This allows the hook to work in test environments or contexts without RelayEnvironmentProvider.
 */ const $5dd52072ecf7ce89$var$useSafeRelayEnvironment = ()=>{
    try {
        return (0, $irOoi.useRelayEnvironment)();
    } catch  {
        // No RelayEnvironmentProvider available, return null
        // The hook will fall back to localStorage-only mode
        return null;
    }
};
const $5dd52072ecf7ce89$export$e7148f1ad1bea80c = (contentContext, useCurrentPageContext, isConversationAgentic, productKey)=>{
    // Get editor context to determine if there's an active editor to stream to
    const [editorContext] = (0, $i1Nyn.useChatContextEditorContext)();
    let autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_editor_context'
    };
    // Agentic conversations handle their own application
    if (isConversationAgentic) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'agentic_conversation'
    };
    else if (contentContext === 'staging-area') autoApplyAvailability = {
        type: 'available'
    };
    else if (!useCurrentPageContext) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_page_context'
    };
    else if (contentContext === 'global' && productKey === 'jira') autoApplyAvailability = {
        type: 'available'
    };
    else if (contentContext === 'global' && Boolean(editorContext)) autoApplyAvailability = {
        type: 'available'
    };
    return {
        autoApplyAvailability: autoApplyAvailability
    };
};
const $5dd52072ecf7ce89$export$97bf7cbb478ab6de = (sessionData, _contentContext, _useCurrentPageContext, _isConversationAgentic)=>{
    const environment = $5dd52072ecf7ce89$var$useSafeRelayEnvironment();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const [enabled, setEnabledState] = (0, $42omo.useState)(()=>(0, $45c1578a6ac72ff4$export$cbd1b24c4f50480f)());
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    // Cache the current state to avoid unnecessary re-renders
    const stateRef = (0, $42omo.useRef)(enabled);
    stateRef.current = enabled;
    // Determine if we should make backend calls (need environment + session + feature gate)
    const shouldUseBackend = environment && sessionData && sessionData.userId && (0, $dh538.fg)('enable_auto_apply_toggling');
    // Determine if we should use localStorage fallback
    const shouldUseLocalStorage = (!sessionData || !sessionData.userId || !environment) && (0, $dh538.fg)('enable_auto_apply_toggling');
    // If feature gate is off, don't provide any auto-apply functionality
    const isFeatureDisabled = !(0, $dh538.fg)('enable_auto_apply_toggling');
    // Load state from backend when component mounts or sessionData changes
    const refresh = (0, $42omo.useCallback)(async ()=>{
        if (isFeatureDisabled) return;
        if (shouldUseBackend) {
            const experienceId = `${(0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE}-${Date.now()}`;
            (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: fetching state from backend for user ${sessionData.userId}`);
            experienceTracker.start({
                id: experienceId,
                name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE
            });
            setLoading(true);
            setError(null);
            try {
                const backendState = await (0, $45c1578a6ac72ff4$export$de3027235ba834ab)(environment, sessionData);
                (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: backend returned autoApply=${backendState}`);
                if (backendState !== stateRef.current) setEnabledState(backendState);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE
                });
            } catch (err) {
                // Store error and keep current state - don't fall back to localStorage
                const error = err instanceof Error ? err : new Error('Failed to fetch auto-apply state');
                (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: failed to fetch state - ${error.message}`);
                setError(error);
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE,
                    error: error
                });
            } finally{
                setLoading(false);
            }
        } else if (shouldUseLocalStorage) {
            const localState = (0, $45c1578a6ac72ff4$export$cbd1b24c4f50480f)();
            if (localState !== stateRef.current) setEnabledState(localState);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Set state with backend persistence
    const setEnabled = (0, $42omo.useCallback)(async (newEnabled)=>{
        if (isFeatureDisabled) return;
        if (newEnabled === stateRef.current) return; // No change needed
        const experienceId = `${(0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE}-${Date.now()}`;
        setLoading(true);
        setError(null);
        try {
            if (shouldUseBackend) {
                (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: setting state to ${newEnabled} via backend`);
                experienceTracker.start({
                    id: experienceId,
                    name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE
                });
                await (0, $45c1578a6ac72ff4$export$284464f4da8ebd9)(environment, sessionData, newEnabled);
                (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: successfully set autoApply=${newEnabled}`);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE,
                    attributes: {
                        autoApplyEnabled: newEnabled
                    }
                });
            } else if (shouldUseLocalStorage) {
                (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: setting state to ${newEnabled} via localStorage`);
                (0, $45c1578a6ac72ff4$export$dedcc43382a0a2d)(newEnabled);
            }
            setEnabledState(newEnabled);
        } catch (err) {
            // Store error and keep current state, don't update UI
            const error = err instanceof Error ? err : new Error('Failed to update auto-apply state');
            (0, $1yaYZ.addSentryBreadcrumb)(`useAutoApplyState: failed to set state - ${error.message}`);
            setError(error);
            if (shouldUseBackend) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE,
                error: error,
                attributes: {
                    autoApplyEnabled: newEnabled
                }
            });
            throw error; // Re-throw so the component can handle it
        } finally{
            setLoading(false);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Initialize state from backend
    (0, $42omo.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        enabled: isFeatureDisabled ? false : enabled,
        loading: isFeatureDisabled ? false : loading,
        error: isFeatureDisabled ? null : error,
        setEnabled: setEnabled,
        refresh: refresh
    };
};
module.exports["useAutoApplyAvailability"] = $5dd52072ecf7ce89$export$e7148f1ad1bea80c;
module.exports["useAutoApplyState"] = $5dd52072ecf7ce89$export$97bf7cbb478ab6de;

});

parcelRegister("5SEdb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $a3fRD = parcelRequire("a3fRD");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $i4C2H = parcelRequire("i4C2H");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $c3meS = parcelRequire("c3meS");


var $lPk3K = parcelRequire("lPk3K");

const $b536e6d938936901$var$styles = {
    previewCardWrapper: "_kqswh2mm",
    previewCard: "_2rko1mok _1h6d1l7x _189ee4h9 _1dqonqa1 _p12f9rak _4t3ivbgk _kqswh2mm _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bozgutpp _bfhkhp5a _irr3116u",
    previewCardContent: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _2rko12b0 _bfhki8nm _4t3ickbl _1bsbckbl _kqswh2mm _1o9zidpf",
    icon: "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
    crossIcon: "_2rko1rr0 _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswstnw _1xi2xmi2 _154ixmi2 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkvuon _4t3i1tcg _1bsb1tcg _tzy4idpf _irr319i6",
    crossIconVisible: "_tzy4kb7n",
    labelWrapper: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    thumbnailImageCover: "_1bsb1osq _4t3i1osq _5ral1dfr",
    clickable: "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _1ygbdfik _1ah3v77o"
};
const $b536e6d938936901$var$LoadingIndicator = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
        size: "small"
    });
};
const $b536e6d938936901$var$MediaContentRenderer = ({ isLoading: isLoading, error: error, imageSrc: imageSrc, cardIcon: cardIcon, errorLabel: errorLabel })=>{
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LoadingIndicator, {});
    if (error) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: errorLabel || error,
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (imageSrc) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "img",
        src: imageSrc,
        alt: "",
        xcss: $b536e6d938936901$var$styles.thumbnailImageCover
    });
    if (cardIcon) return cardIcon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3meS))),
        alt: ""
    });
};
const $b536e6d938936901$var$MediaWrapper = ({ show: show = true, ...contentProps })=>{
    if (!show) return null;
    const shouldShowCentered = contentProps.isLoading || contentProps.error;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b536e6d938936901$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
            interactionName: "rovo-conversation-assistant-preview-card",
            fallback: /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LoadingIndicator, {}),
            children: contentProps.imageSrc && !shouldShowCentered ? /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaContentRenderer, {
                ...contentProps
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    !contentProps.isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3meS))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $b536e6d938936901$var$styles.icon,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaContentRenderer, {
                            ...contentProps
                        })
                    })
                ]
            })
        })
    });
};
const $b536e6d938936901$var$RemoveButton = ({ onRemove: onRemove, isVisible: isVisible = false, removeLabel: removeLabel })=>{
    if (!onRemove) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onRemove,
        xcss: (0, $1Whri.cx)($b536e6d938936901$var$styles.crossIcon, isVisible && $b536e6d938936901$var$styles.crossIconVisible),
        "data-remove-button": "true",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: removeLabel || '',
            spacing: "compact",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        })
    });
};
const $b536e6d938936901$var$useAutoScroll = (autoScroll)=>{
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (autoScroll && ref.current) ref.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        autoScroll
    ]);
    return ref;
};
const $b536e6d938936901$var$LabelContent = ({ label: label, subLabel: subLabel, subLabelIcon: subLabelIcon })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $b536e6d938936901$var$styles.previewCardContent,
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b536e6d938936901$var$styles.labelWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text",
                    size: "medium",
                    children: label
                })
            }),
            subLabel && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                alignBlock: "center",
                children: [
                    subLabelIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                        interactionName: "rovo-conversation-assistant-preview-card-sublabel-icon",
                        fallback: null,
                        children: subLabelIcon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        children: subLabel
                    })
                ]
            })
        ]
    });
const $b536e6d938936901$export$b56e55a3645a3ec = ({ onRemove: onRemove, onClick: onClick, isLoading: isLoading, error: error, autoScroll: autoScroll, label: label, subLabel: subLabel, subLabelIcon: subLabelIcon, cardIcon: cardIcon, imageSrc: imageSrc, removeLabel: removeLabel, errorLabel: errorLabel, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const ref = $b536e6d938936901$var$useAutoScroll(autoScroll);
    const showMedia = !!(cardIcon || imageSrc);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        // Don't trigger onClick if clicking the remove button
        if (e.target.closest('[data-remove-button]')) return;
        onClick?.();
    }, [
        onClick
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((e)=>{
        // Handle Enter and Space keys for accessibility
        if (e.key === 'Enter' || e.key === ' ') {
            if (e.target.closest('[data-remove-button]')) return;
            e.preventDefault();
            onClick?.();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: error || label,
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $b536e6d938936901$var$styles.previewCardWrapper,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            onFocus: ()=>setIsHovered(true),
            onBlur: ()=>setIsHovered(false),
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    ref: ref,
                    testId: testId,
                    tabIndex: onClick ? 0 : undefined,
                    role: onClick ? 'button' : undefined,
                    onClick: onClick ? handleClick : undefined,
                    onKeyDown: onClick ? handleKeyDown : undefined,
                    xcss: onClick ? $b536e6d938936901$var$styles.clickable : undefined,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            xcss: $b536e6d938936901$var$styles.previewCard,
                            alignBlock: "center",
                            space: "space.150",
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LabelContent, {
                                    label: label,
                                    subLabel: subLabel,
                                    subLabelIcon: subLabelIcon
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaWrapper, {
                                    show: showMedia,
                                    isLoading: isLoading,
                                    error: error,
                                    imageSrc: imageSrc,
                                    cardIcon: cardIcon,
                                    errorLabel: errorLabel
                                })
                            ]
                        }),
                        isLoading ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            role: "status",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                                children: formatMessage((0, $lPk3K.default).loadingLabel, {
                                    label: label
                                })
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$RemoveButton, {
                    onRemove: onRemove,
                    isVisible: isHovered && !!onRemove,
                    removeLabel: removeLabel
                })
            ]
        })
    });
};
module.exports["PreviewCard"] = $b536e6d938936901$export$b56e55a3645a3ec;

});

parcelRegister("c3meS", function(module, exports) {
module.exports = new URL("preview-bg.12045916.svg", import.meta.url).toString();

});

parcelRegister("lPk3K", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $19c78f61533d0c6f$var$previewCardMessages = (0, $aXWIB.defineMessages)({
    loadingLabel: {
        id: "ai-mate.preview-card.loading-label",
        defaultMessage: "Loading {label}"
    }
});
var $19c78f61533d0c6f$export$2e2bcd8739ae039 = $19c78f61533d0c6f$var$previewCardMessages;
module.exports["default"] = $19c78f61533d0c6f$export$2e2bcd8739ae039;

});


//# sourceMappingURL=FullPageEditorComponent.3260f9dd.js.map
